// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBotComponent_chatbotMiddle__\\+9hva {
  position: fixed;
  bottom: -10px;
  width: 100%;
}
.ChatBotComponent_responsiveContainer__Nm1aC {
  display: flex; /* Default for desktop */
  gap: 30px;
}

/* For screens 768px wide or smaller */
@media (max-width: 768px) {
  .ChatBotComponent_responsiveContainer__Nm1aC {
    flex-direction: column;
  }
  .ChatBotComponent_filterTileCard__QMZwf {
    padding: 8px !important;
    min-height: auto !important;
  }

  .ChatBotComponent_filterTileCard__QMZwf.ChatBotComponent_smallFilterTile__yKyou {
    padding: 8px !important;
    min-height: auto !important;
    min-width: none;
  }
}

/* Additional responsive reductions for filter panel controls (tablet and mobile) */
@media screen and (max-width: 900px) {
  /* Reduce calendar picker width */
  .ChatBotComponent_pickerContainer__kyaKu {
    width: 260px !important;
  }

  /* Ensure AI responses are left-aligned (even when short) */
  /* Slightly smaller month buttons */
  .ChatBotComponent_monthButton__Vs60Q {
    padding: 0.3rem 0.22rem;
    font-size: 0.72rem;
    border-radius: 12px;
  }

  /* Smaller selected bullets and labels */
  .ChatBotComponent_chipLabel__ErYCu {
    padding: 5px 10px;
    font-size: 0.82rem;
  }

  .ChatBotComponent_chipRadio__MH4Zf {
    width: 14px;
    height: 14px;
  }

  .ChatBotComponent_filterPanelContainer__dyxCz {
    padding: 8px !important;
  }

  .ChatBotComponent_filterGroupName__5oxL\\+ {
    font-size: 0.88rem;
  }

  .ChatBotComponent_selectAllButton__bBRz9 {
    padding: 6px 8px;
    font-size: 0.5rem;
    font-weight: bold;
  }

  /* Make filter tiles more compact on small screens */
  .ChatBotComponent_filterTileCard__QMZwf {
    padding: 8px !important;
    min-height: auto !important;
  }

  .ChatBotComponent_filterTileCard__QMZwf.ChatBotComponent_smallFilterTile__yKyou {
    padding: 8px !important;
    min-height: auto !important;
  }

  /* Reduce gaps and chip sizes to save vertical space */
  .ChatBotComponent_regionRetailerRow__Rwz5E {
    gap: 8px !important;
  }

  .ChatBotComponent_chipContainer__Uu3JF,
  .ChatBotComponent_retailerChipContainer__jCcly {
    gap: 6px !important;
  }

  .ChatBotComponent_chipLabel__ErYCu {
    padding: 4px 8px !important;
    font-size: 0.78rem !important;
  }

  .ChatBotComponent_chipRadio__MH4Zf {
    width: 12px !important;
    height: 12px !important;
  }

  .ChatBotComponent_categoryChipContainer__Ouvf6 {
    max-height: 240px !important; /* reduce vertical footprint */
  }

  .ChatBotComponent_regionColumn__GPVW4 {
    flex: none !important;
    max-width: 100% !important;
    width: 100% !important;
  }
}

/* On very narrow screens make the picker and its selected-range box slightly narrower */
@media screen and (max-width: 420px) {
  .ChatBotComponent_pickerContainer__kyaKu {
    max-width: 240px !important;
    width: 100% !important;
  }

  .ChatBotComponent_selectedRangeBox__14UJD {
    max-width: 240px !important;
  }
  /* make category chips narrower on very small screens */
  .ChatBotComponent_categoryChipContainer__Ouvf6 .ChatBotComponent_chipLabel__ErYCu {
    width: 240px !important;
  }
}

/* Layout adjustments specifically for the period comparison pickers and apply button */
@media screen and (max-width: 900px) {
  .ChatBotComponent_periodPickerRow__btZam {
    flex-direction: column !important;
    /* gap: 12px !important; */
  }

  .ChatBotComponent_pickerColumn__uwzRS {
    padding: 0 !important;
    border: none !important;
    width: 100% !important;
  }

  /* Make the picker containers narrower and allow horizontal scroll if needed */
  .ChatBotComponent_pickerContainer__kyaKu {
    width: 220px !important;
    padding: 0.25rem !important;
  }

  .ChatBotComponent_applyFiltersRow__m8d8b {
    justify-content: center !important;
  }

  .ChatBotComponent_applyFiltersRow__m8d8b .ChatBotComponent_MuiButtonBase-root__dkKni,
  .ChatBotComponent_applyFiltersRow__m8d8b button {
    width: 100% !important; /* Make the Apply Filters button full width on mobile */
    max-width: 320px !important;
  }
}

/* Layout for Category + Period side-by-side on wide screens, stacked on small screens */
.ChatBotComponent_categoryWithPeriod__tmU5o {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.ChatBotComponent_categoryWithPeriodRow__64O8G {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
}

/* Allow the two-column container to wrap onto multiple lines if space is constrained */
.ChatBotComponent_categoryWithPeriodRow__64O8G {
  flex-wrap: wrap;
}

@media screen and (max-width: 900px) {
  .ChatBotComponent_categoryWithPeriod__tmU5o,
  .ChatBotComponent_categoryWithPeriodRow__64O8G {
    flex-direction: column !important;
  }

  /* Ensure both columns (category + period) become full width and any inline maxWidth
     (for example the left column's maxWidth: 320px set inline in JSX) is overridden
     so tiles appear uniform on small screens. */
  .ChatBotComponent_categoryWithPeriodRow__64O8G > div,
  .ChatBotComponent_categoryWithPeriodRow__64O8G > div:last-child,
  .ChatBotComponent_regionRetailerRow__Rwz5E > div {
    max-width: 100% !important;
    width: 100% !important;
    flex: none !important;
  }

  /* Make filter tiles fill their parent column and use border-box so padding doesn't
     change visual widths. Use !important to override inline styles when necessary. */
  .ChatBotComponent_filterTileCard__QMZwf,
  .ChatBotComponent_filterTileCard__QMZwf.ChatBotComponent_smallFilterTile__yKyou {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
}

/* Ensure filter tiles inside the left column occupy full width and align with Region tile */
.ChatBotComponent_categoryWithPeriodRow__64O8G > div > .ChatBotComponent_filterTileCard__QMZwf {
  width: 100%;
  box-sizing: border-box;
}

/* Allow the two pickers within the period panel to wrap and avoid overflowing */
.ChatBotComponent_periodPickerRow__btZam {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.ChatBotComponent_chatbotBottom__4QxSU {
  /* display: flex;
    justify-content: center;
    margin: 10px 0;
    bottom: 10px;
    width: 100%; */
  position: fixed;
  /* reduce bottom offset so footer occupies slightly less vertical space */
  bottom: -4px;
  width: 100%;
}

/* Keep body overflow hidden only on wide desktops; allow scrolling on smaller/tablet viewports
   to avoid double scrollbars / overlap (fixes iPad Mini overlap issues). */
@media screen and (min-width: 901px) {
  body {
    overflow: hidden;
  }
}

@media screen and (max-width: 900px) {
  body {
    overflow: auto;
  }

  /* Avoid fixed positioning on small/tablet sizes so the app flow and native scrollbar
     are not overlapped by fixed footer/header elements. */
  .ChatBotComponent_chatbotMiddle__\\+9hva,
  .ChatBotComponent_chatbotBottom__4QxSU {
    position: static !important;
    bottom: auto !important;
    width: 100% !important;
  }

  /* Constrain messages area so its internal scrollbar doesn't overlap with device UI */
  .ChatBotComponent_messages__xqD4K {
    position: static !important;
    top: 0 !important;
    height: auto !important;
    max-height: calc(
      100vh - 120px
    ) !important; /*leave room for header/footer  */
    padding: 50px 6% 80px 7% !important; /* a bit more bottom padding for floating controls */
    overflow-y: auto !important;
    margin-left: 3% !important;
  }

  /* Make sure native scrollbars are visible and use standard sizes on tablets */
  .ChatBotComponent_messages__xqD4K::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .ChatBotComponent_messages__xqD4K {
    -ms-overflow-style: auto; /* IE 10+ */
    scrollbar-width: auto; /* Firefox */
  }
}

.ChatBotComponent_messages__xqD4K {
  /* flex: 1;
    overflow-y: auto;
    margin-bottom: 10px;
    padding: 20px;
    height: 73vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 10%;
    padding-right: 10%;
    overflow: initial; */

  flex: 1 1;
  width: 100%;
  height: 100vh;
  justify-content: center;
  /* align-items: center; */
  padding: 104px 0 0 0; /* top accounts for both headers */
  display: flex;
  align-items: flex-start;
  flex-direction: column; /* optional, if stacking children vertically */
  gap: 10px; /* spacing between child elements */
  /* opacity: 2; */
  position: static; /* to apply 'top' */
  /* top: -30px; */
  /* overflow-y: auto; */
}

.ChatBotComponent_tipsClass__GU20D {
  text-align: "left";
  margin-left: 25px;
}

.ChatBotComponent_tipsIcon__HQwG1 {
  height: 15px !important;
  width: 15px !important;
  margin-bottom: 5px;
  margin-right: 2px;
  margin-left: -6px;
}

/* .messages::-webkit-scrollbar {
    display: none;
}

.messages {
  -ms-overflow-style: none;
  scrollbar-width: none;
} */

.ChatBotComponent_messages__xqD4K img {
  /* Allow message images to use available width while preserving aspect ratio.
     Small avatar/icon images are controlled by their specific selectors (.avatar img, .aiavatar img). */
  /* max-width: 100%;
  height: auto;
  display: block; */
  width: 70%;
  height: 70%;
}

.ChatBotComponent_sentMessage__Vpyor {
  /* Use block-level right alignment instead of float so short messages don't appear centered.
     margin-left:auto pushes this block to the right within its parent container. */
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  max-width: 80%;
  position: relative;
  background-color: #eff5fc;
  border: 1px solid #d7e5f8;
  color: #3a3a3a;
  font-size: 14px;
  font-weight: 400;
  margin-left: auto; /* aligns the message to the right */
  overflow-wrap: anywhere;
  float: right;
}

.ChatBotComponent_receivedMessage__l4GNP {
  /* margin: 10px 0 0 0; */
  padding: 0px 12px 0px 12px ;
  border-radius: 0px;
  position: relative;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  min-width: 8%;
  overflow-wrap: anywhere;
  max-width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  font-size: 12px; /* Or 0.9rem, or whatever size you prefer */
  line-height: 1.6; /* Increases spacing between lines for readability */
  color: #333;
  /* Ensure AI responses are left-aligned (even when short) */
  display: block;
  margin-right: auto;
}

.ChatBotComponent_mainDiv__M6NPd {
  width: 100%;
  /* margin-top: 94px;  */
  /* first header (~42px) + second white header (~52px) */
  font-size: 12px;
}
.ChatBotComponent_closeIcon__MDnVh{
  width: 1rem !important;
  height: 1rem !important;
}
.ChatBotComponent_userFeedbackContainer__rPEPT {
  background-color: #f7f7f7;
  height: 100vh;
}

.ChatBotComponent_gridContainer__OEAVS {
  height: 93.2vh;
}

/* side panel */
.ChatBotComponent_sidePanelTrigger__IQ\\+KC {
  position: fixed;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 100px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  writing-mode: vertical-rl;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: all 0.3s ease;
}

.ChatBotComponent_sidePanelTrigger__IQ\\+KC:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%) scale(1.05);
}

/* --- Chat response typography & table sizing ---
   Keep the text sizes consistent inside the chat messages area (both docked and expanded).
   These selectors target headings, paragraphs and tables rendered inside the .messages container.
--- */
.ChatBotComponent_messages__xqD4K h1,
.ChatBotComponent_messages__xqD4K h2,
.ChatBotComponent_messages__xqD4K h3,
.ChatBotComponent_messages__xqD4K h4,
.ChatBotComponent_messages__xqD4K h5,
.ChatBotComponent_messages__xqD4K h6 {
  /* reduce heading sizes used by the rendered responses */
  margin: 0.5rem 0 0.25rem 0;
  font-weight: 600;
  line-height: 1.2;
}
.ChatBotComponent_messages__xqD4K h1 {
  font-size: 1.5rem;
}
.ChatBotComponent_messages__xqD4K h2 {
  font-size: 1.25rem;
}
.ChatBotComponent_messages__xqD4K h3 {
  font-size: 1rem;
}
.ChatBotComponent_messages__xqD4K h4 {
  font-size: 0.9rem;
}
.ChatBotComponent_messages__xqD4K h5 {
  font-size: 0.85rem;
}
.ChatBotComponent_messages__xqD4K h6 {
  font-size: 0.8rem;
}

.ChatBotComponent_messages__xqD4K p,
.ChatBotComponent_messages__xqD4K li,
.ChatBotComponent_messages__xqD4K span,
.ChatBotComponent_messages__xqD4K div {
  /* keep body text compact but readable */
  font-size: 0.9rem;
  line-height: 1.4;
}

.ChatBotComponent_messages__xqD4K table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem; /* make table text smaller */
}
.ChatBotComponent_messages__xqD4K th,
.ChatBotComponent_messages__xqD4K td {
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  text-align: left;
  vertical-align: top;
  font-size: 0.78rem; /* slightly smaller for cells */
  white-space: nowrap;
}

/* Ensure the message bubble text sizes don't scale when the panel is expanded */
.ChatBotComponent_messages__xqD4K .ChatBotComponent_receivedMessage__l4GNP,
.ChatBotComponent_messages__xqD4K .ChatBotComponent_sentMessage__Vpyor {
  font-size: 0.9rem !important;
  line-height: 1.45 !important;
}

/* Improve table responsiveness inside chat messages */
.ChatBotComponent_messages__xqD4K .ChatBotComponent_table-responsive__4zPaN {
  overflow-x: auto;
}

/* Make tables horizontally scrollable inside the receivedMessage bubble */
.ChatBotComponent_receivedMessage__l4GNP {
  overflow-x: auto;
}

.ChatBotComponent_receivedMessage__l4GNP table {
  width: 100%;
  display: table;
}

.ChatBotComponent_sidePanel__bzr5\\+ {
  position: fixed;
  left: -250px;
  top: 0;
  width: 200px;
  height: 70%;
  margin-top: 3% !important;
  background-color: #f4f4f4;
  transition: left 0.3s ease;
  box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);
}

.ChatBotComponent_sidePanelContent__luY3u {
  /* reduced padding to make side panel header/footer more compact */
  padding: 8px 12px;
}

/* Hover effect */
.ChatBotComponent_sidePanelTrigger__IQ\\+KC:hover + .ChatBotComponent_sidePanel__bzr5\\+,
.ChatBotComponent_sidePanel__bzr5\\+:hover {
  left: 0;
}

.ChatBotComponent_rightSidePanelTrigger__5-rFo {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 100px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  writing-mode: vertical-rl;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: all 0.3s ease;
}

.ChatBotComponent_rightSidePanelTrigger__5-rFo:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%) scale(1.05);
}

.ChatBotComponent_rightSidePanel__\\+6FDA {
  position: fixed;
  right: -600px;
  top: 0;
  width: 30%;
  height: 93%;
  margin-top: 3% !important;
  background-color: #f4f4f4;
  transition: left 0.3s ease;
  box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);
  z-index: 100;
}

.ChatBotComponent_rightSidePanelContent__YGdww {
  /* reduced padding to make side panel header/footer more compact */
  padding: 8px 12px;
}

/* Hover effect */
.ChatBotComponent_rightSidePanelTrigger__5-rFo:hover + .ChatBotComponent_rightSidePanel__\\+6FDA,
.ChatBotComponent_rightSidePanel__\\+6FDA:hover {
  right: 0;
}

.ChatBotComponent_outerDiv__o1cWl {
  width: 100%;
  /* margin: 10px 0px; */
}

.ChatBotComponent_outerDiv__o1cWl > * {
  display: inline-block;
}

.ChatBotComponent_plusIcon__2NZ5S {
  height: 35px;
  width: 35px;
}

.ChatBotComponent_newChatIcon__b8Syt {
  /* margin-right: 5px; */
  margin-left: -13px !important;
  position: relative;
  /* bottom: 15px; */
}

.ChatBotComponent_disableMicBtn__MRqxx {
  margin-bottom: 0px;
}

.ChatBotComponent_activeMicIcon__Y6bD- {
  margin-bottom: -10px;
  background-color: #e9e9e9 !important;
  color: #626262 !important;
  cursor: unset !important;
  pointer-events: none;
}

.ChatBotComponent_chat_message__p29Hz {
  flex: 1 1;
  padding: 10px;
  overflow-y: scroll;
  border-right: 1px solid #ccc;
  /* To separate input from chat history */
}

.ChatBotComponent_histText__zvO2N {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 10px !important;
  /* width: 100px; */

  span {
    font-size: 12px !important;
  }
}

.ChatBotComponent_semiDividerHome__b1-Tb {
  position: relative;
  height: 1px;
  background-color: #acacac;
  border-radius: 10px;
}

.ChatBotComponent_typing_effect__IGJUR {
  font-family: Arial, sans-serif;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  animation: ChatBotComponent_typing__Rvd0l 3s steps(20, end) backwards;
  display: inline-block;
  padding-bottom: 20px;
  color: #0047ba;
}

@keyframes ChatBotComponent_typing__Rvd0l {
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
}

/* Tile/card style for filter groups (Region/Retailer) */
.ChatBotComponent_filterTileCard__QMZwf {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  min-height: 132px;
}

.ChatBotComponent_regionRetailerRow__Rwz5E {
  align-items: flex-start;
}

.ChatBotComponent_generateInsightsGridRow__zOmZO {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
  align-items: end;
}

.ChatBotComponent_generateInsightsGridCell__nru8z {
  min-width: 0;
  width: 100%;
}

.ChatBotComponent_generateInsightsGridRetailerStore__grAqO {
  grid-column: span 2;
}

@media screen and (max-width: 900px) {
  .ChatBotComponent_filterTileCard__QMZwf {
    min-height: auto;
    padding: 10px;
  }

  .ChatBotComponent_generateInsightsGridRow__zOmZO {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ChatBotComponent_generateInsightsGridRetailerStore__grAqO {
    grid-column: 1 / -1;
  }

  .ChatBotComponent_regionRetailerRow__Rwz5E {
    flex-direction: column !important;
  }
}

/* smaller variant used for compact period tiles */
.ChatBotComponent_smallFilterTile__yKyou {
  /* padding: 10px; */
  min-height: 150px; /* match screenshot box height */
}

.ChatBotComponent_chipCls__O93dy {
  margin-right: 10px !important;
  cursor: pointer;
}

.ChatBotComponent_chipCls__O93dy:hover {
  background-color: #f4f4f4;
}

.ChatBotComponent_intro__pxFcm {
  text-align: center;
  padding: 5px 0px;
}

.ChatBotComponent_alignCenter__c7q1M {
  margin: 0 auto;
}

.ChatBotComponent_intro__pxFcm div {
  color: #3a3a3a;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
}

.ChatBotComponent_intro__pxFcm p {
  color: #616161;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.ChatBotComponent_sendIcon__16hRo {
  /* slightly smaller send icon to reduce footer height */
  height: 20px;
  border-radius: 4px;
  width: 20px;
  cursor: pointer;
  display: block;
  padding: 0px; /* smaller tappable area while keeping accessibility */
  border-radius: 6px;
  box-sizing: content-box;
  margin-bottom: 0;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.06));
}

.ChatBotComponent_avatar__mssXo {
  /* Make avatar inline so message bubbles control alignment. */
  float: right;
  /* display: inline-block; */
  vertical-align: middle;
  margin: 0px 0px 0px 10px;
}

.ChatBotComponent_avatar__mssXo img {
  height: 32px;
  width: 32px;
  padding-bottom: 2px;
}

/* Inline SVG avatar styling */
.ChatBotComponent_chatBotSvg__I8DVd {
  height: 32px;
  width: 32px;
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 2px;
}

.ChatBotComponent_chatBotSvg__I8DVd path {
  /* allow the SVG fill to be controlled by CSS if needed */
  fill: currentColor;
}

.ChatBotComponent_aiavatar__hB3IO {
  float: left;
  position: relative;
  top: 7px;
  margin: 0px 10px 0px 0px;
  max-height: 40px;
  max-width: 40px;
  padding-right: 5px;
}

.ChatBotComponent_aiavatar__hB3IO img {
  height: 24px;
  width: 24px;
}

.ChatBotComponent_moreOptions__-yECI {
  bottom: -6px;
  height: 10px;
  width: 10px;
  right: 35px;
}

.ChatBotComponent_moreOptions__-yECI:focus {
  outline: none;
}

.ChatBotComponent_aiChatMessage__EtOEd {
  display: block;
  width: 100%;
}

.ChatBotComponent_aiChatMessage__EtOEd > * {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.ChatBotComponent_suggestionBtn__Qz-Xc {
  margin-bottom: 10px;
  margin-left: 30px;
}

.ChatBotComponent_suggestionBtn__Qz-Xc > button {
  border: 1px solid #d7e5f8;
  border-radius: 4px;
  background-color: #fff;
  text-align: left;
  font-size: 10px;
}

.ChatBotComponent_suggestionIcon__GkhAB {
  float: left;
  position: relative;
  top: 7px;
  margin: 0px 10px 0px 0px;
  padding: 4px;
  font-size: 10px;
  border-radius: 15px;
  background: #4197b2;
}

/* Filter UI tweaks */
/* Pill-shaped chip label with radio indicator */
.ChatBotComponent_chipLabel__ErYCu {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 2px 10px;
  font-size: 8px; /* slightly larger and more readable */
  border-radius: 999px; /* pill */
  border: 1px solid #d8d8d8; /* light outline when unselected */
  background: #ffffff;
  color: #333333;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
  box-shadow: none;
}

/* Visual radio indicator on the left of the chip using pseudo-element */
.ChatBotComponent_chipLabel__ErYCu::before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  /* show small white center with a subtle ring for unchecked */
  background: radial-gradient(circle at center, #ffffff 55%, #cfcfcf 56%);
  flex-shrink: 0;
}

.ChatBotComponent_chipRadio__MH4Zf {
  display: none; /* hide native input - we render indicator via ::before */
}

.ChatBotComponent_filterGroupName__5oxL\\+ {
  font-size: 13px;
  font-weight: 700;
  color: #222;
}

.ChatBotComponent_filterItem__pxw5j {
  margin-bottom: 8px;
}

.ChatBotComponent_filterItemLabel__-niuQ {
  font-size: 12px;
}

.ChatBotComponent_selectAllButton__bBRz9 {
  background: transparent;
  border: 0;
  color: #659cd6;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 8px;
  font-weight: 600;
}

.ChatBotComponent_suggestionIcon__GkhAB > svg {
  background-color: #4197b2;
  color: #fff;
  font-size: 17px;
}

.ChatBotComponent_anchorul__M2Ute {
  list-style-type: none;
  float: right;
  position: fixed;
  right: 0px;
  max-width: 150px;
  margin-right: 20px;
}

.ChatBotComponent_anchorul__M2Ute > li > div {
  border: none;
  padding: 5px;
  background: #fff;
  border-left: 2px solid #acc6e1;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 110px;
  cursor: pointer;
}

.ChatBotComponent_anchorul__M2Ute > li:active {
  border: none !important;
  outline: none !important;
}

.ChatBotComponent_activeLinkClass__RH7vk {
  border-left: 2px solid #005cbc !important;
}

.ChatBotComponent_feedback__e56Zw {
  position: relative;
  left: -10%;
  top: -10px;
  z-index: 0;
}

.ChatBotComponent_inputFieldContainer__L6LZH {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  text-align: start;
  /* margin-left: 5%; */
  /* make the input/footer area more compact */
  /* padding: 4px 0; */
}

.ChatBotComponent_inputFieldGrid__Efcfi {
  background: #fff;
  /* bottom: 10px; */
  position: relative;
  /* margin: 0 auto !important; */
  margin: 0 auto;
  display: block !important;
  /* display: flex; */
  /* width: 70% !important; */
  flex-direction: column;
  align-items: center;
  width: 60%;
  max-width: 1205px;
}

.ChatBotComponent_autoCompleteItem__2o0Il {
  width: 100%;
  display: inline-block;
  padding: 0px 8px 0px 0px !important;
}

.ChatBotComponent_query__Gli9n {
  border: 1px solid;
  border-radius: 4px;
  padding: 2%;
  cursor: pointer;

  &:hover {
    background-color: lightgrey;
  }
}

.ChatBotComponent_emptyQueries__rz7aj {
  margin: auto;
  width: 50%;
  padding: 10px;
}

.ChatBotComponent_clearAll__JSAXp {
  float: right;
  background: unset !important;
  color: #0047ba !important;
  font-weight: 700;
  border: unset;
  padding: unset;

  &:focus {
    color: black;
    background: transparent;
    outline: none;
    box-shadow: none;
  }
}

.ChatBotComponent_dropdown__GzPpF {
  float: left;
  position: relative;
  top: 7px;
  margin: 0px 10px 10px 50px;
  display: inline;
  justify-content: center;
}

.ChatBotComponent_formControl__QSxO2 {
  margin-right: 10px;
  height: 20px;
}

.ChatBotComponent_loadingContainer__8Iccr {
  margin-top: 5px;
  position: fixed;
  bottom: 95px;
  /* left: 300px; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 1000;
  pointer-events: none;
}

.ChatBotComponent_loadingMessage__Mdp0D {
  font-size: 11px;
  font-weight: bold;
  color: transparent;
  /* background-color: rgba(255, 255, 255, 0.98); */
  /* padding: 12px 20px; */
  /* border-radius: 8px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
  max-width: 300px;
  /* text-align: left; */
  /* background: linear-gradient(90deg, rgb(133, 128, 128) 0%, white 50%, rgb(133, 128, 128) 100%); */
  /* background: linear-gradient(90deg, black 0%, white 50%, black 100%); */
  background: black;
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  /* animation: shine 3s infinite linear; */
  /* animation-duration: 4s; */
}

@keyframes ChatBotComponent_shine__WUR1u {
  0% {
    background-position: 200%;
  }
  100% {
    background-position: -200%;
  }
}

.ChatBotComponent_loadingMessage__Mdp0D.ChatBotComponent_disabled__6zhSw {
  animation: none;
}

@media screen and (min-width: 350px) and (max-width: 500px) {
  /* .wrapper{
        margin-top: 60px;
    } */
  .ChatBotComponent_aiavatar__hB3IO {
    margin-right: -5px;
    margin: 0;
  }

  .ChatBotComponent_autoCompleteItem__2o0Il {
    width: 100%;
  }

  .ChatBotComponent_suggestions__Fr-sf {
    max-width: 80%;
  }

  .ChatBotComponent_messages__xqD4K {
    padding-left: unset;
    padding-right: unset;
    height: 80vh;
  }

  .ChatBotComponent_receivedMessage__l4GNP {
    max-width: 100%;
  }

  .ChatBotComponent_inputFieldContainer__L6LZH {
    margin-left: unset;
  }

  .ChatBotComponent_inputFieldGrid__Efcfi {
    width: 100% !important;
  }

  .ChatBotComponent_moreOptionsWeb__9w2DN {
    display: none;
  }

  .ChatBotComponent_moreOptionsMobile__66hGc {
    float: right;
    margin-bottom: unset;
    margin-right: -30px;
  }

  .ChatBotComponent_anchorul__M2Ute {
    display: none;
  }

  .ChatBotComponent_feedback__e56Zw {
    position: relative;
    left: -10%;
    top: 40px;
    z-index: 0;
  }

  /* .outerDiv {
    margin: 120px 0px 0px 0px;
  } */

  /* .newChatIcon {
        margin-right: 5px;
        position: absolute;
        top: -25px;
    } */

  /* .disableMicBtn{
        position: relative;
        top: 20px;
    } */

  /* .activeMicIcon{
        position: relative;
        top: 20px;
    } */

  /* .sendIcon {
        position: relative;
        top: 18px;
    } */
}

@media screen and (min-width: 900px) {
  .ChatBotComponent_moreOptionsMobile__66hGc {
    display: none;
  }

  .ChatBotComponent_feedback__e56Zw {
    position: relative;
    /* margin-left: 25%; */
    top: 30px;
    z-index: 0;
  }
}
.ChatBotComponent_summaryIntroText__DnzTB {
  font-size: 16px; /* Adjust size as needed */
  font-weight: 300; /* This makes the font regular, not bold */
  color: #272727; /* A standard, soft text color */
  margin-bottom: 10px; /* Adds some space before the horizontal line */
}
.ChatBotComponent_summarySeparator__pSUJC {
  border: none;
  height: 1px;
  background-color: #a0a0a0; /* A light grey color */
  margin-top: 10px;
  margin-bottom: 10px;
}
/* In ChatBotComponent.module.css */

/* In ChatBotComponent.module.css */
/* Remove .topFilterContainer, .dropdown, and old .filterAccordionHeader/.filterTitle styles */

/* This is the main card container for the entire filter panel */
.ChatBotComponent_filterPanelContainer__dyxCz {
  /* position: fixed; */
  /* background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%); */
  /* background: linear-gradient(180deg, #f4f8ff 0%, #edf4ff 100%); */
  border-radius: 14px;
  /* border: 1px solid #dce8f8; */
  /* box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08); */
  /* margin-bottom: 16px; */
  padding: 10px 10px 6px 10px; /* top, right, bottom, left*/
  /* max-width: 1280px;  */
  width: 100%; /* This makes it take the full available width */
  /* max-width and margin-left/right are removed */
  /* width: 100%;
  min-width: 1024px; optional: set a fixed min width if needed */
  box-sizing: border-box;
  /* max-width: 900px; */
  justify-content: space-between;
}

/* Styles for the clickable header area */
.ChatBotComponent_filterAccordionHeader__ATdbq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0 0 0px 5px; /* Reduced padding */
}

/* Refined style for the title text */
.ChatBotComponent_filterTitle__jfT6o {
  font-size: 12px; /* Slightly larger */
  font-weight: 500;
  color: #08090b; /* Softer black */
  margin: -10;
}

/* This new class adds padding to the content inside the collapsible area */
.ChatBotComponent_topFilterContainer__zP9Gw {
  padding: 0 0 0 -10; /* Only top padding, no side padding */
}

/* This is the container for each label + dropdown pair */
.ChatBotComponent_filterItem__pxw5j {
  display: flex;
  /* min-Width: 180; */
  padding-top: -20px; /* Adjusts the space above the label */
  flex-direction: column;
  gap: -40px; /* Controls the space between the label and the dropdown */
  /* padding: auto;*/
}

.ChatBotComponent_regionColumn__GPVW4 {
  flex: 0 0 300px;
  max-width: 340px;
}
.ChatBotComponent_filterItemLabel__-niuQ {
  font-size: 12px;
  font-weight: 400;
  color: #000000; /* A professional, slightly muted text color */
  /* margin-left: 10px; */
  text-transform: capitalize; /* Ensures consistent casing */
}

.ChatBotComponent_pageWrapper__KA2L\\+ {
  /* max-width: 1280px; */
  /* margin-top: 4rem; */
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 6rem);
  /* height: calc(80vh); */
  box-sizing: border-box;
  /* padding: 0 16px; */
}

.ChatBotComponent_stickyContainer__jLXzU {
  position: fixed;
  top: 50px;
  z-index: 10;
  /* margin-right: 5%; */
  /* width: 90%; */
  /* align-items: center; */
  /* box-shadow: 0 0px 0px rgba(234, 233, 233, 0.05); */
  min-height: 60px;
  box-sizing: border-box;
}

.ChatBotComponent_scrollableContent__9bHZA {
  margin-top: 104px; /* Adjust for combined header height (first: ~44px + second: ~52px) */
  /* height: calc(100vh - 10px); */
  flex-grow: 1;
  overflow-y: auto;
  z-index: 5;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  position: relative;

  scrollbar-width: none;
  -ms-overflow-style: none;
  /* padding: 8px; */
  margin: 0;
  /* margin-right: 2%; */
  /* Allow pointer events to pass through to scrollbar */
  pointer-events: auto;
  width: 100%;
}

/* Hide scrollbar for summary mode (default) */
.ChatBotComponent_scrollableContent__9bHZA::-webkit-scrollbar {
  display: none;
}

/* Show scrollbar ONLY for chat mode */
.ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"] {
  scrollbar-width: auto;
  -ms-overflow-style: auto;
  overflow-y: scroll;
}

.ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar {
  display: block;
  width: 12px;
}

.ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar-thumb {
  background: #a0b8d4;
  border-radius: 6px;
  min-height: 40px;
  background-clip: padding-box;
  border: 2px solid transparent;
}

.ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar-track {
  background: #f0f4fa;
  border-radius: 8px;
}

/* In summary mode, keep outer area fixed and let only the inner right content panel scroll. */
.ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="summary"] {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* On mobile, ensure scrollbar is always visible and wider for chat mode */
@media screen and (max-width: 900px) {
  .ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"] {
    scrollbar-width: auto !important;
    overflow-y: scroll !important;
  }

  .ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar {
    display: block;
    width: 14px;
  }

  .ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar-thumb {
    background: #7a94b8;
    border-radius: 7px;
  }

  .ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="chat"]::-webkit-scrollbar-track {
    background: #e8eef8;
  }
}

/* Ensure scrollable content is always interactive even during loading */
.ChatBotComponent_scrollableContent__9bHZA * {
  pointer-events: auto !important;
}

.ChatBotComponent_scrollButtonsWrapper__cF4rP,
.ChatBotComponent_scrollButtonsContainer__YldJ3 {
  /* Fixed at the bottom center so placement is consistent across screen sizes
     Raised to sit above the input field and tips area */
  position: fixed;
  bottom: 97px; /* moved up so buttons appear above chat input */
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  gap: 10px;
  background: transparent;
  z-index: 1200; /* ensure above other content */
}

.ChatBotComponent_scrollButton__57Kl1 {
  background: none;
  border: none;
  color: #4a484f;
  /* font-weight: 700; */
  font-size: 17px;
  /* cursor: pointer; */
  padding: 0;
  outline: none;
  /* transition: color 0.3s ease-in-out, transform 0.2s ease-in-out; */
}

/* Larger hit target for touch devices */
.ChatBotComponent_scrollButton__57Kl1 {
  /* width: 40px; */
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.ChatBotComponent_scrollButton__57Kl1:hover {
  color: #161517;
  transform: scale(1.1);
}
.ChatBotComponent_scrollButton__57Kl1:focus {
  outline: none;
  transform: scale(1.1); /* slight click animation */
}
.ChatBotComponent_actionBar__uPg\\+o {
  display: flex; /* Aligns children (options and feedback icons) in a row */
  align-items: center; /* Vertically centers the items in the bar */
  gap: 8px;
  margin-top: 0px; /* Adds some space above the action bar */
  justify-content: flex-end;
  padding-bottom: 10px;
}

/* Styles for the feedback icons container */
.ChatBotComponent_feedback__e56Zw {
  display: flex;
  gap: 8px;
  position: static;
  top: auto;
  left: auto;
  align-items: center;
  justify-content: flex-end;
  padding-left: 0;
  margin-left: auto;
}
.ChatBotComponent_feedback__e56Zw .mr15 {
  margin-right: 0 !important;
}
.ChatBotComponent_feedback__e56Zw svg {
  width: 28px;
  height: 28px;
  padding: 7px;
  border: 1px solid #d5dbe5;
  border-radius: 999px;
  background: #f7f9fc;
  color: #005CBC;
  box-sizing: border-box;
}

/* Period comparison panel styles */
.ChatBotComponent_periodPanelContent__9hqs1 {
  margin-top: 5px;
}

.ChatBotComponent_selectedRangeBox__14UJD {
  margin-top: 5px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 6px;
  color: #444;
  font-size: 0.7rem;
  display: flex;
  align-items: center; /* vertical centering */
  justify-content: center; /* horizontal centering */
  text-align: center; /* fallback for inline text */
  border: 1px solid #e0e0e0;
  width: 100%;
  max-width: 280px; /* align with MonthRangePicker.module.css pickerContainer max-width */
  box-sizing: border-box;
  min-height: 20px; /* ensure enough height to vertically center the placeholder */
}

@media screen and (max-width: 900px) {
  /* Stack the two period panels on small screens */
  .ChatBotComponent_periodPanelContent__9hqs1 {
    width: 100% !important;
  }

  /* Make scroll buttons slightly closer together and nearer to the bottom on small screens */
  .ChatBotComponent_scrollButtonsWrapper__cF4rP,
  .ChatBotComponent_scrollButtonsContainer__YldJ3 {
    bottom: 64px;
    /* gap: 12px; */
  }
}
/* Add these to ChatBotComponent.module.css */

.ChatBotComponent_filterGroup__siFbA {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  /* margin-bottom: 16px; */
}

.ChatBotComponent_filterGroupHeader__FsORy {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  /* margin-bottom: 8px; */
}

/* Variant for when we want the action (Clear/Select All) inline with the label */
.ChatBotComponent_filterGroupHeaderInline__2Lq4J {
  justify-content: flex-start;
  gap: 8px;
}

/* Wrapper to keep label and action compact and aligned to the left */
.ChatBotComponent_filterGroupHeaderInlineWrap__UG7F7 {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: flex-start; /* keep Clear button next to label */
}

.ChatBotComponent_filterGroupName__5oxL\\+ {
  font-weight: bold;
  font-size: 0.7rem;
  color: #333;
}

.ChatBotComponent_selectAllButton__bBRz9 {
  font-size: 0.6rem;
  color: #659cd6;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
}

.ChatBotComponent_chipContainer__Uu3JF {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ChatBotComponent_retailerChipContainer__jCcly {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.ChatBotComponent_regionRetailerRow__Rwz5E {
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: flex-start;
}

@media (max-width: 768px) {
  .ChatBotComponent_retailerChipContainer__jCcly {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;
  }
  .ChatBotComponent_regionColumn__GPVW4 {
    flex: 0 0;
    max-width: 340px;
  }
  .ChatBotComponent_regionRetailerRow__Rwz5E {
    flex-direction: column;
    gap: 16px; /* Add some vertical space between the stacked sections */
  }

  /* Ensure each section takes the full width on mobile */
  .ChatBotComponent_regionRetailerRow__Rwz5E > div {
    max-width: 100%;
    width: 100%;
  }
}

/* Vertical layout specifically for Category chips (single-select radio list) */
.ChatBotComponent_categoryChipContainer__Ouvf6 {
  display: flex;
  flex-direction: column;
  /* gap: 6px; tightened vertical spacing for category list */
  max-height: 420px; /* allow scrolling if too many categories */
  overflow-y: auto;
}

/* Make category chips compact: don't force them to stretch full tile width.
   Use inline-flex so the pill sizes to its content but never exceeds the tile width. */
.ChatBotComponent_categoryChipContainer__Ouvf6 {
  align-items: stretch; /* keep vertical stacking */
}
.ChatBotComponent_categoryChipContainer__Ouvf6 .ChatBotComponent_chipLabel__ErYCu {
  display: flex; /* uniform fixed-width pill */
  align-items: center;
  justify-content: flex-start;
  width: 50%;
  /* padding: 6px 6px; */
  border-radius: 12px; /* slightly rounded rectangular */
  box-sizing: border-box;
  /* height: 31px;  */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Make the input-radio pseudo and label align well when the container scrolls */
.ChatBotComponent_categoryChipContainer__Ouvf6 input[type="radio"] + .ChatBotComponent_chipLabel__ErYCu {
  box-sizing: border-box;
}

.ChatBotComponent_chipRadio__MH4Zf {
  display: none; /* Hide the actual radio button */
}

/* Checked state: blue filled pill and updated indicator */
.ChatBotComponent_chipRadio__MH4Zf:checked + .ChatBotComponent_chipLabel__ErYCu {
  background-color: #327ec9; /* brand blue when selected */
  border-color: #327ec9;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(43, 143, 230, 0.12);
}

.ChatBotComponent_chipRadio__MH4Zf:checked + .ChatBotComponent_chipLabel__ErYCu::before {
  /* white center with colored ring using radial-gradient to show the circular indicator */
  background: radial-gradient(circle at center, #ffffff 55%, #327ec9 56%);
}
.ChatBotComponent_filterGroup__siFbA:not(:last-child) {
  border-bottom: 1px dotted #e0e0e0;
  /* padding-bottom: 16px; Adds some space between the content and the divider */
}
.ChatBotComponent_filter_button__Q8dqx {
  display: flex;
  gap: 8px;
  width: 100%;
}

@media screen and (min-width: 768px) and (max-width: 900px) {
  .ChatBotComponent_filterHamburgerButton__BMlTc {
    position: absolute !important;
    top: 5px;
    right: 5px;
    z-index: 1300;
    background-color: #ffffff !important;
  }
  .ChatBotComponent_mobileFilterDrawer__4VygA {
    width: 300px;
    padding: 1rem;
    box-sizing: border-box;
  }
  .ChatBotComponent_drawerHeader__AdUQz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  }
  .ChatBotComponent_drawerTitle__W5Neb {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
  }
  /* Make each filter dropdown take the full width to stack vertically */
  .ChatBotComponent_filterItem__pxw5j {
    flex-basis: 100%;
    min-width: unset;
  }
  /* Hide hover-based side panels as they are not touch-friendly */
  .ChatBotComponent_sidePanelTrigger__IQ\\+KC,
  .ChatBotComponent_rightSidePanelTrigger__5-rFo,
  .ChatBotComponent_sidePanel__bzr5\\+,
  .ChatBotComponent_rightSidePanel__\\+6FDA {
    display: none;
  }
  .ChatBotComponent_filterTitle__jfT6o {
    font-size: 13px; /* Kept from original tablet styles */
    line-height: 1.4;
  }
  .ChatBotComponent_scrollableContent__9bHZA,
  .ChatBotComponent_scrollableContent__9bHZA.ChatBotComponent_filtersExpanded__b5TIo {
    /* Target both the base and expanded states */
    margin-left: auto;
    margin-right: auto;
    padding:0 8px;
    box-sizing: border-box;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    max-width: 1280px;
  }
  .ChatBotComponent_pageWrapper__KA2L\\+ {
    height: calc(100vh - 12rem);
    /* display: contents; */
  }
  .ChatBotComponent_messages__xqD4K {
    padding: 50px;
    display: block;
    position: relative;
  }
  .ChatBotComponent_sentMessage__Vpyor,
  .ChatBotComponent_receivedMessage__l4GNP {
    max-width: 100%;
    font-size: 14px;
  }

  /* Ensure the input area takes full width */
  .ChatBotComponent_inputFieldContainer__L6LZH {
    margin-left: 0;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* Hide hover-based side panels as they are not touch-friendly */
  .ChatBotComponent_sidePanelTrigger__IQ\\+KC,
  .ChatBotComponent_rightSidePanelTrigger__5-rFo,
  .ChatBotComponent_sidePanel__bzr5\\+,
  .ChatBotComponent_rightSidePanel__\\+6FDA {
    display: none;
  }

  /* Align feedback icons to the left */
  .ChatBotComponent_feedback__e56Zw {
    padding-left: 0;
    justify-content: flex-end;
  }
  .ChatBotComponent_filter_button__Q8dqx{
    flex-direction: column;
  }
}

@media screen and (max-width: 767px) {
  body {
    overflow: hidden;
  }
  .ChatBotComponent_filterHamburgerButton__BMlTc {
    position: absolute !important;
    top: 5px;
    right: 5px;
    z-index: 1300; /* Ensure it's on top */
    background-color: #ffffff !important;
    /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); */
  }
  .ChatBotComponent_mobileFilterDrawer__4VygA {
    width: 300px; /* Or whatever width you prefer */
    padding: 1rem;
    box-sizing: border-box;
  }
  .ChatBotComponent_drawerHeader__AdUQz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e0e0e0; /* Adds a nice separator line */
  }

  .ChatBotComponent_drawerTitle__W5Neb {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
  }

  /* Adjust the chat content area to flow naturally */
  .ChatBotComponent_scrollableContent__9bHZA,
  .ChatBotComponent_scrollableContent__9bHZA.ChatBotComponent_filtersExpanded__b5TIo {
    /* Target both the base and expanded states */
    margin-top: 0; /* Ensure margin is always 0 on mobile */
    padding: 0 10px;
    box-sizing: border-box;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
 .ChatBotComponent_scrollableContent__9bHZA[data-ui-mode="summary"] {
    /* margin-top: 20%; */
    position: absolute;
    padding: 0px 10px;
    top: 112px;
  }

  .ChatBotComponent_pageWrapper__KA2L\\+ {
    /* margin-top: 30px; */
    height: calc(100vh - 11rem);
    /* display: contents; */
  }

  /* Make each filter dropdown take the full width to stack vertically */
  .ChatBotComponent_filterItem__pxw5j {
    flex-basis: 100%;
    min-width: unset;
  }

  .ChatBotComponent_filterTitle__jfT6o {
    font-size: 12px;
  }

  /* Adjust message padding and max-width for better readability */
  .ChatBotComponent_messages__xqD4K {
    padding: 10px;
    display: block;
    position: relative;
  }
  .ChatBotComponent_sentMessage__Vpyor,
  .ChatBotComponent_receivedMessage__l4GNP {
    max-width: 100%;
    font-size: 14px;
  }

  /* Ensure the input area takes full width */
  .ChatBotComponent_inputFieldContainer__L6LZH {
    margin-left: 0;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* Hide hover-based side panels as they are not touch-friendly */
  .ChatBotComponent_sidePanelTrigger__IQ\\+KC,
  .ChatBotComponent_rightSidePanelTrigger__5-rFo,
  .ChatBotComponent_sidePanel__bzr5\\+,
  .ChatBotComponent_rightSidePanel__\\+6FDA {
    display: none;
  }

  /* Align feedback icons to the left */
  .ChatBotComponent_feedback__e56Zw {
    padding-left: 0;
    justify-content: flex-end;
  }

  /* Hide the floating scroll-to-question list */
  .ChatBotComponent_anchorul__M2Ute {
    display: none;
  }
   .ChatBotComponent_filter_button__Q8dqx{
    flex-direction: column;
  }
}
.ChatBotComponent_custom-btn__uH8mU:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/UaeMt/ChatBotComponent.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa,EAAE,wBAAwB;EACvC,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA,mFAAmF;AACnF;EACE,iCAAiC;EACjC;IACE,uBAAuB;EACzB;;EAEA,2DAA2D;EAC3D,mCAAmC;EACnC;IACE,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,wCAAwC;EACxC;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,oDAAoD;EACpD;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,sDAAsD;EACtD;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B,EAAE,8BAA8B;EAC9D;;EAEA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA,wFAAwF;AACxF;EACE;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;EACA,uDAAuD;EACvD;IACE,uBAAuB;EACzB;AACF;;AAEA,uFAAuF;AACvF;EACE;IACE,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA,8EAA8E;EAC9E;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;;IAEE,sBAAsB,EAAE,uDAAuD;IAC/E,2BAA2B;EAC7B;AACF;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA,uFAAuF;AACvF;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,iCAAiC;EACnC;;EAEA;;gDAE8C;EAC9C;;;IAGE,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;qFACmF;EACnF;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA,4FAA4F;AAC5F;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;;;;kBAIgB;EAChB,eAAe;EACf,yEAAyE;EACzE,YAAY;EACZ,WAAW;AACb;;AAEA;2EAC2E;AAC3E;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;0DACwD;EACxD;;IAEE,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA,qFAAqF;EACrF;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB;;gBAEY,EAAE,iCAAiC;IAC/C,mCAAmC,EAAE,oDAAoD;IACzF,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,8EAA8E;EAC9E;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,wBAAwB,EAAE,WAAW;IACrC,qBAAqB,EAAE,YAAY;EACrC;AACF;;AAEA;EACE;;;;;;;;;;wBAUsB;;EAEtB,SAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB,EAAE,kCAAkC;EACxD,aAAa;EACb,uBAAuB;EACvB,sBAAsB,EAAE,8CAA8C;EACtE,SAAS,EAAE,mCAAmC;EAC9C,gBAAgB;EAChB,gBAAgB,EAAE,mBAAmB;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;;;;GAOG;;AAEH;EACE;wGACsG;EACtG;;mBAEiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE;mFACiF;EACjF,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,oCAAoC;EACvD,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf;qBACmB;EACnB,eAAe,EAAE,2CAA2C;EAC5D,gBAAgB,EAAE,oDAAoD;EACtE,WAAW;EACX,2DAA2D;EAC3D,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,uDAAuD;EACvD,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;;;KAGK;AACL;;;;;;EAME,wDAAwD;EACxD,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB,EAAE,4BAA4B;AACjD;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAE,+BAA+B;EACnD,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;;EAEE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,kEAAkE;EAClE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;EAEE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;EAEE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;;EAElB;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qEAA6C;EAC7C,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY,EAAE,sDAAsD;EACpE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc,EAAE,sCAAsC;EACtD,oBAAoB,EAAE,SAAS;EAC/B,yBAAyB,EAAE,kCAAkC;EAC7D,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;2CACyC;EACzC,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,yDAAyD;AAC1E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;;EAEf;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,cAAc;;EAEd;IACE,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,wBAAwB;EACxB,wBAAwB;EACxB,+CAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,mGAAmG;EACnG,yEAAyE;EACzE,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;OAEK;EACL;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;EACZ;;EAEA;;KAEG;;EAEH;;;;OAIK;;EAEL;;;OAGK;;EAEL;;;OAGK;;EAEL;;;OAGK;AACP;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB,EAAE,0CAA0C;EAC5D,cAAc,EAAE,gCAAgC;EAChD,mBAAmB,EAAE,+CAA+C;AACtE;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB,EAAE,uBAAuB;EAClD,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mCAAmC;;AAEnC,mCAAmC;AACnC,8FAA8F;;AAE9F,gEAAgE;AAChE;EACE,qBAAqB;EACrB,mEAAmE;EACnE,mEAAmE;EACnE,mBAAmB;EACnB,+BAA+B;EAC/B,oDAAoD;EACpD,yBAAyB;EACzB,2BAA2B,EAAE,4BAA4B;EACzD,wBAAwB;EACxB,WAAW,EAAE,gDAAgD;EAC7D,gDAAgD;EAChD;gEAC8D;EAC9D,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,oBAAoB,EAAE,oBAAoB;AAC5C;;AAEA,qCAAqC;AACrC;EACE,eAAe,EAAE,oBAAoB;EACrC,gBAAgB;EAChB,cAAc,EAAE,iBAAiB;EACjC,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB,EAAE,sCAAsC;EAC1D,sBAAsB;EACtB,UAAU,EAAE,0DAA0D;EACtE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,8CAA8C;EAC9D,uBAAuB;EACvB,0BAA0B,EAAE,8BAA8B;AAC5D;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,qDAAqD;EACrD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB,EAAE,qEAAqE;EACxF,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;;EAElB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,sDAAsD;EACtD,oBAAoB;EACpB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8FAA8F;AAC9F;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;EACE;IACE,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,wEAAwE;AACxE;EACE,+BAA+B;AACjC;;AAEA;;EAEE;wDACsD;EACtD,eAAe;EACf,YAAY,EAAE,gDAAgD;EAC9D,SAAS;EACT,2BAA2B;;EAE3B,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa,EAAE,+BAA+B;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,oEAAoE;AACtE;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,aAAa,EAAE,0DAA0D;EACzE,mBAAmB,EAAE,4CAA4C;EACjE,QAAQ;EACR,eAAe,EAAE,yCAAyC;EAC1D,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,kBAAkB,EAAE,6BAA6B;EACjD,yBAAyB;EACzB,WAAW;EACX,gBAAgB,EAAE,qEAAqE;EACvF,sBAAsB;EACtB,gBAAgB,EAAE,8DAA8D;AAClF;;AAEA;EACE,iDAAiD;EACjD;IACE,sBAAsB;EACxB;;EAEA,2FAA2F;EAC3F;;IAEE,YAAY;IACZ,eAAe;EACjB;AACF;AACA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,iFAAiF;AACjF;EACE,2BAA2B;EAC3B,QAAQ;AACV;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,SAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,SAAS,EAAE,yDAAyD;EACtE;;EAEA,uDAAuD;EACvD;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,2DAA2D;EAC3D,iBAAiB,EAAE,2CAA2C;EAC9D,gBAAgB;AAClB;;AAEA;uFACuF;AACvF;EACE,oBAAoB,EAAE,2BAA2B;AACnD;AACA;EACE,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;EACtB,mBAAmB,EAAE,iCAAiC;EACtD,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB,EAAE,6BAA6B;EACxD,qBAAqB;EACrB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,wFAAwF;EACxF,uEAAuE;AACzE;AACA;EACE,iCAAiC;EACjC,8EAA8E;AAChF;AACA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;IACE,6BAA6B;IAC7B,QAAQ;IACR,UAAU;IACV,aAAa;IACb,oCAAoC;EACtC;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;EAClC;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;EACA,sEAAsE;EACtE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA,gEAAgE;EAChE;;;;IAIE,aAAa;EACf;EACA;IACE,eAAe,EAAE,qCAAqC;IACtD,gBAAgB;EAClB;EACA;;IAEE,6CAA6C;IAC7C,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;EACA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,cAAc;IACd,sBAAsB;EACxB;;EAEA,gEAAgE;EAChE;;;;IAIE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,QAAQ;IACR,UAAU;IACV,aAAa,EAAE,uBAAuB;IACtC,oCAAoC;IACpC,8CAA8C;EAChD;EACA;IACE,YAAY,EAAE,iCAAiC;IAC/C,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC,EAAE,+BAA+B;EACnE;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA,mDAAmD;EACnD;;IAEE,6CAA6C;IAC7C,aAAa,EAAE,wCAAwC;IACvD,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;CACD;IACG,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA,sEAAsE;EACtE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,gEAAgE;EAChE;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;EACA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,cAAc;IACd,sBAAsB;EACxB;;EAEA,gEAAgE;EAChE;;;;IAIE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;GACC;IACC,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;AACf","sourcesContent":[".chatbotMiddle {\n  position: fixed;\n  bottom: -10px;\n  width: 100%;\n}\n.responsiveContainer {\n  display: flex; /* Default for desktop */\n  gap: 30px;\n}\n\n/* For screens 768px wide or smaller */\n@media (max-width: 768px) {\n  .responsiveContainer {\n    flex-direction: column;\n  }\n  .filterTileCard {\n    padding: 8px !important;\n    min-height: auto !important;\n  }\n\n  .filterTileCard.smallFilterTile {\n    padding: 8px !important;\n    min-height: auto !important;\n    min-width: none;\n  }\n}\n\n/* Additional responsive reductions for filter panel controls (tablet and mobile) */\n@media screen and (max-width: 900px) {\n  /* Reduce calendar picker width */\n  .pickerContainer {\n    width: 260px !important;\n  }\n\n  /* Ensure AI responses are left-aligned (even when short) */\n  /* Slightly smaller month buttons */\n  .monthButton {\n    padding: 0.3rem 0.22rem;\n    font-size: 0.72rem;\n    border-radius: 12px;\n  }\n\n  /* Smaller selected bullets and labels */\n  .chipLabel {\n    padding: 5px 10px;\n    font-size: 0.82rem;\n  }\n\n  .chipRadio {\n    width: 14px;\n    height: 14px;\n  }\n\n  .filterPanelContainer {\n    padding: 8px !important;\n  }\n\n  .filterGroupName {\n    font-size: 0.88rem;\n  }\n\n  .selectAllButton {\n    padding: 6px 8px;\n    font-size: 0.5rem;\n    font-weight: bold;\n  }\n\n  /* Make filter tiles more compact on small screens */\n  .filterTileCard {\n    padding: 8px !important;\n    min-height: auto !important;\n  }\n\n  .filterTileCard.smallFilterTile {\n    padding: 8px !important;\n    min-height: auto !important;\n  }\n\n  /* Reduce gaps and chip sizes to save vertical space */\n  .regionRetailerRow {\n    gap: 8px !important;\n  }\n\n  .chipContainer,\n  .retailerChipContainer {\n    gap: 6px !important;\n  }\n\n  .chipLabel {\n    padding: 4px 8px !important;\n    font-size: 0.78rem !important;\n  }\n\n  .chipRadio {\n    width: 12px !important;\n    height: 12px !important;\n  }\n\n  .categoryChipContainer {\n    max-height: 240px !important; /* reduce vertical footprint */\n  }\n\n  .regionColumn {\n    flex: none !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n}\n\n/* On very narrow screens make the picker and its selected-range box slightly narrower */\n@media screen and (max-width: 420px) {\n  .pickerContainer {\n    max-width: 240px !important;\n    width: 100% !important;\n  }\n\n  .selectedRangeBox {\n    max-width: 240px !important;\n  }\n  /* make category chips narrower on very small screens */\n  .categoryChipContainer .chipLabel {\n    width: 240px !important;\n  }\n}\n\n/* Layout adjustments specifically for the period comparison pickers and apply button */\n@media screen and (max-width: 900px) {\n  .periodPickerRow {\n    flex-direction: column !important;\n    /* gap: 12px !important; */\n  }\n\n  .pickerColumn {\n    padding: 0 !important;\n    border: none !important;\n    width: 100% !important;\n  }\n\n  /* Make the picker containers narrower and allow horizontal scroll if needed */\n  .pickerContainer {\n    width: 220px !important;\n    padding: 0.25rem !important;\n  }\n\n  .applyFiltersRow {\n    justify-content: center !important;\n  }\n\n  .applyFiltersRow .MuiButtonBase-root,\n  .applyFiltersRow button {\n    width: 100% !important; /* Make the Apply Filters button full width on mobile */\n    max-width: 320px !important;\n  }\n}\n\n/* Layout for Category + Period side-by-side on wide screens, stacked on small screens */\n.categoryWithPeriod {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.categoryWithPeriodRow {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n}\n\n/* Allow the two-column container to wrap onto multiple lines if space is constrained */\n.categoryWithPeriodRow {\n  flex-wrap: wrap;\n}\n\n@media screen and (max-width: 900px) {\n  .categoryWithPeriod,\n  .categoryWithPeriodRow {\n    flex-direction: column !important;\n  }\n\n  /* Ensure both columns (category + period) become full width and any inline maxWidth\n     (for example the left column's maxWidth: 320px set inline in JSX) is overridden\n     so tiles appear uniform on small screens. */\n  .categoryWithPeriodRow > div,\n  .categoryWithPeriodRow > div:last-child,\n  .regionRetailerRow > div {\n    max-width: 100% !important;\n    width: 100% !important;\n    flex: none !important;\n  }\n\n  /* Make filter tiles fill their parent column and use border-box so padding doesn't\n     change visual widths. Use !important to override inline styles when necessary. */\n  .filterTileCard,\n  .filterTileCard.smallFilterTile {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n  }\n}\n\n/* Ensure filter tiles inside the left column occupy full width and align with Region tile */\n.categoryWithPeriodRow > div > .filterTileCard {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Allow the two pickers within the period panel to wrap and avoid overflowing */\n.periodPickerRow {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.chatbotBottom {\n  /* display: flex;\n    justify-content: center;\n    margin: 10px 0;\n    bottom: 10px;\n    width: 100%; */\n  position: fixed;\n  /* reduce bottom offset so footer occupies slightly less vertical space */\n  bottom: -4px;\n  width: 100%;\n}\n\n/* Keep body overflow hidden only on wide desktops; allow scrolling on smaller/tablet viewports\n   to avoid double scrollbars / overlap (fixes iPad Mini overlap issues). */\n@media screen and (min-width: 901px) {\n  body {\n    overflow: hidden;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  body {\n    overflow: auto;\n  }\n\n  /* Avoid fixed positioning on small/tablet sizes so the app flow and native scrollbar\n     are not overlapped by fixed footer/header elements. */\n  .chatbotMiddle,\n  .chatbotBottom {\n    position: static !important;\n    bottom: auto !important;\n    width: 100% !important;\n  }\n\n  /* Constrain messages area so its internal scrollbar doesn't overlap with device UI */\n  .messages {\n    position: static !important;\n    top: 0 !important;\n    height: auto !important;\n    max-height: calc(\n      100vh - 120px\n    ) !important; /*leave room for header/footer  */\n    padding: 50px 6% 80px 7% !important; /* a bit more bottom padding for floating controls */\n    overflow-y: auto !important;\n    margin-left: 3% !important;\n  }\n\n  /* Make sure native scrollbars are visible and use standard sizes on tablets */\n  .messages::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  .messages {\n    -ms-overflow-style: auto; /* IE 10+ */\n    scrollbar-width: auto; /* Firefox */\n  }\n}\n\n.messages {\n  /* flex: 1;\n    overflow-y: auto;\n    margin-bottom: 10px;\n    padding: 20px;\n    height: 73vh;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-left: 10%;\n    padding-right: 10%;\n    overflow: initial; */\n\n  flex: 1;\n  width: 100%;\n  height: 100vh;\n  justify-content: center;\n  /* align-items: center; */\n  padding: 104px 0 0 0; /* top accounts for both headers */\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column; /* optional, if stacking children vertically */\n  gap: 10px; /* spacing between child elements */\n  /* opacity: 2; */\n  position: static; /* to apply 'top' */\n  /* top: -30px; */\n  /* overflow-y: auto; */\n}\n\n.tipsClass {\n  text-align: \"left\";\n  margin-left: 25px;\n}\n\n.tipsIcon {\n  height: 15px !important;\n  width: 15px !important;\n  margin-bottom: 5px;\n  margin-right: 2px;\n  margin-left: -6px;\n}\n\n/* .messages::-webkit-scrollbar {\n    display: none;\n}\n\n.messages {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n} */\n\n.messages img {\n  /* Allow message images to use available width while preserving aspect ratio.\n     Small avatar/icon images are controlled by their specific selectors (.avatar img, .aiavatar img). */\n  /* max-width: 100%;\n  height: auto;\n  display: block; */\n  width: 70%;\n  height: 70%;\n}\n\n.sentMessage {\n  /* Use block-level right alignment instead of float so short messages don't appear centered.\n     margin-left:auto pushes this block to the right within its parent container. */\n  display: block;\n  padding: 8px 12px;\n  border-radius: 6px;\n  max-width: 80%;\n  position: relative;\n  background-color: #eff5fc;\n  border: 1px solid #d7e5f8;\n  color: #3a3a3a;\n  font-size: 14px;\n  font-weight: 400;\n  margin-left: auto; /* aligns the message to the right */\n  overflow-wrap: anywhere;\n  float: right;\n}\n\n.receivedMessage {\n  /* margin: 10px 0 0 0; */\n  padding: 0px 12px 0px 12px ;\n  border-radius: 0px;\n  position: relative;\n  border: 1px solid #ffffff;\n  background-color: #ffffff;\n  min-width: 8%;\n  overflow-wrap: anywhere;\n  max-width: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif;\n  font-size: 12px; /* Or 0.9rem, or whatever size you prefer */\n  line-height: 1.6; /* Increases spacing between lines for readability */\n  color: #333;\n  /* Ensure AI responses are left-aligned (even when short) */\n  display: block;\n  margin-right: auto;\n}\n\n.mainDiv {\n  width: 100%;\n  /* margin-top: 94px;  */\n  /* first header (~42px) + second white header (~52px) */\n  font-size: 12px;\n}\n.closeIcon{\n  width: 1rem !important;\n  height: 1rem !important;\n}\n.userFeedbackContainer {\n  background-color: #f7f7f7;\n  height: 100vh;\n}\n\n.gridContainer {\n  height: 93.2vh;\n}\n\n/* side panel */\n.sidePanelTrigger {\n  position: fixed;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 100px;\n  background-color: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  writing-mode: vertical-rl;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n.sidePanelTrigger:hover {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  transform: translateY(-50%) scale(1.05);\n}\n\n/* --- Chat response typography & table sizing ---\n   Keep the text sizes consistent inside the chat messages area (both docked and expanded).\n   These selectors target headings, paragraphs and tables rendered inside the .messages container.\n--- */\n.messages h1,\n.messages h2,\n.messages h3,\n.messages h4,\n.messages h5,\n.messages h6 {\n  /* reduce heading sizes used by the rendered responses */\n  margin: 0.5rem 0 0.25rem 0;\n  font-weight: 600;\n  line-height: 1.2;\n}\n.messages h1 {\n  font-size: 1.5rem;\n}\n.messages h2 {\n  font-size: 1.25rem;\n}\n.messages h3 {\n  font-size: 1rem;\n}\n.messages h4 {\n  font-size: 0.9rem;\n}\n.messages h5 {\n  font-size: 0.85rem;\n}\n.messages h6 {\n  font-size: 0.8rem;\n}\n\n.messages p,\n.messages li,\n.messages span,\n.messages div {\n  /* keep body text compact but readable */\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.messages table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem; /* make table text smaller */\n}\n.messages th,\n.messages td {\n  padding: 6px 8px;\n  border: 1px solid #e0e0e0;\n  text-align: left;\n  vertical-align: top;\n  font-size: 0.78rem; /* slightly smaller for cells */\n  white-space: nowrap;\n}\n\n/* Ensure the message bubble text sizes don't scale when the panel is expanded */\n.messages .receivedMessage,\n.messages .sentMessage {\n  font-size: 0.9rem !important;\n  line-height: 1.45 !important;\n}\n\n/* Improve table responsiveness inside chat messages */\n.messages .table-responsive {\n  overflow-x: auto;\n}\n\n/* Make tables horizontally scrollable inside the receivedMessage bubble */\n.receivedMessage {\n  overflow-x: auto;\n}\n\n.receivedMessage table {\n  width: 100%;\n  display: table;\n}\n\n.sidePanel {\n  position: fixed;\n  left: -250px;\n  top: 0;\n  width: 200px;\n  height: 70%;\n  margin-top: 3% !important;\n  background-color: #f4f4f4;\n  transition: left 0.3s ease;\n  box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);\n}\n\n.sidePanelContent {\n  /* reduced padding to make side panel header/footer more compact */\n  padding: 8px 12px;\n}\n\n/* Hover effect */\n.sidePanelTrigger:hover + .sidePanel,\n.sidePanel:hover {\n  left: 0;\n}\n\n.rightSidePanelTrigger {\n  position: fixed;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 100px;\n  background-color: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  writing-mode: vertical-rl;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n.rightSidePanelTrigger:hover {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.rightSidePanel {\n  position: fixed;\n  right: -600px;\n  top: 0;\n  width: 30%;\n  height: 93%;\n  margin-top: 3% !important;\n  background-color: #f4f4f4;\n  transition: left 0.3s ease;\n  box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);\n  z-index: 100;\n}\n\n.rightSidePanelContent {\n  /* reduced padding to make side panel header/footer more compact */\n  padding: 8px 12px;\n}\n\n/* Hover effect */\n.rightSidePanelTrigger:hover + .rightSidePanel,\n.rightSidePanel:hover {\n  right: 0;\n}\n\n.outerDiv {\n  width: 100%;\n  /* margin: 10px 0px; */\n}\n\n.outerDiv > * {\n  display: inline-block;\n}\n\n.plusIcon {\n  height: 35px;\n  width: 35px;\n}\n\n.newChatIcon {\n  /* margin-right: 5px; */\n  margin-left: -13px !important;\n  position: relative;\n  /* bottom: 15px; */\n}\n\n.disableMicBtn {\n  margin-bottom: 0px;\n}\n\n.activeMicIcon {\n  margin-bottom: -10px;\n  background-color: #e9e9e9 !important;\n  color: #626262 !important;\n  cursor: unset !important;\n  pointer-events: none;\n}\n\n.chat_message {\n  flex: 1;\n  padding: 10px;\n  overflow-y: scroll;\n  border-right: 1px solid #ccc;\n  /* To separate input from chat history */\n}\n\n.histText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 10px !important;\n  /* width: 100px; */\n\n  span {\n    font-size: 12px !important;\n  }\n}\n\n.semiDividerHome {\n  position: relative;\n  height: 1px;\n  background-color: #acacac;\n  border-radius: 10px;\n}\n\n.typing_effect {\n  font-family: Arial, sans-serif;\n  font-size: 1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  animation: typing 3s steps(20, end) backwards;\n  display: inline-block;\n  padding-bottom: 20px;\n  color: #0047ba;\n}\n\n@keyframes typing {\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n\n/* Tile/card style for filter groups (Region/Retailer) */\n.filterTileCard {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  padding: 8px;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n  min-height: 132px;\n}\n\n.regionRetailerRow {\n  align-items: flex-start;\n}\n\n.generateInsightsGridRow {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 8px;\n  width: 100%;\n  align-items: end;\n}\n\n.generateInsightsGridCell {\n  min-width: 0;\n  width: 100%;\n}\n\n.generateInsightsGridRetailerStore {\n  grid-column: span 2;\n}\n\n@media screen and (max-width: 900px) {\n  .filterTileCard {\n    min-height: auto;\n    padding: 10px;\n  }\n\n  .generateInsightsGridRow {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .generateInsightsGridRetailerStore {\n    grid-column: 1 / -1;\n  }\n\n  .regionRetailerRow {\n    flex-direction: column !important;\n  }\n}\n\n/* smaller variant used for compact period tiles */\n.smallFilterTile {\n  /* padding: 10px; */\n  min-height: 150px; /* match screenshot box height */\n}\n\n.chipCls {\n  margin-right: 10px !important;\n  cursor: pointer;\n}\n\n.chipCls:hover {\n  background-color: #f4f4f4;\n}\n\n.intro {\n  text-align: center;\n  padding: 5px 0px;\n}\n\n.alignCenter {\n  margin: 0 auto;\n}\n\n.intro div {\n  color: #3a3a3a;\n  text-align: center;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.intro p {\n  color: #616161;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.sendIcon {\n  /* slightly smaller send icon to reduce footer height */\n  height: 20px;\n  border-radius: 4px;\n  width: 20px;\n  cursor: pointer;\n  display: block;\n  padding: 0px; /* smaller tappable area while keeping accessibility */\n  border-radius: 6px;\n  box-sizing: content-box;\n  margin-bottom: 0;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.06));\n}\n\n.avatar {\n  /* Make avatar inline so message bubbles control alignment. */\n  float: right;\n  /* display: inline-block; */\n  vertical-align: middle;\n  margin: 0px 0px 0px 10px;\n}\n\n.avatar img {\n  height: 32px;\n  width: 32px;\n  padding-bottom: 2px;\n}\n\n/* Inline SVG avatar styling */\n.chatBotSvg {\n  height: 32px;\n  width: 32px;\n  display: inline-block;\n  vertical-align: middle;\n  padding-bottom: 2px;\n}\n\n.chatBotSvg path {\n  /* allow the SVG fill to be controlled by CSS if needed */\n  fill: currentColor;\n}\n\n.aiavatar {\n  float: left;\n  position: relative;\n  top: 7px;\n  margin: 0px 10px 0px 0px;\n  max-height: 40px;\n  max-width: 40px;\n  padding-right: 5px;\n}\n\n.aiavatar img {\n  height: 24px;\n  width: 24px;\n}\n\n.moreOptions {\n  bottom: -6px;\n  height: 10px;\n  width: 10px;\n  right: 35px;\n}\n\n.moreOptions:focus {\n  outline: none;\n}\n\n.aiChatMessage {\n  display: block;\n  width: 100%;\n}\n\n.aiChatMessage > * {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.suggestionBtn {\n  margin-bottom: 10px;\n  margin-left: 30px;\n}\n\n.suggestionBtn > button {\n  border: 1px solid #d7e5f8;\n  border-radius: 4px;\n  background-color: #fff;\n  text-align: left;\n  font-size: 10px;\n}\n\n.suggestionIcon {\n  float: left;\n  position: relative;\n  top: 7px;\n  margin: 0px 10px 0px 0px;\n  padding: 4px;\n  font-size: 10px;\n  border-radius: 15px;\n  background: #4197b2;\n}\n\n/* Filter UI tweaks */\n/* Pill-shaped chip label with radio indicator */\n.chipLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 2px 10px;\n  font-size: 8px; /* slightly larger and more readable */\n  border-radius: 999px; /* pill */\n  border: 1px solid #d8d8d8; /* light outline when unselected */\n  background: #ffffff;\n  color: #333333;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n    color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: none;\n}\n\n/* Visual radio indicator on the left of the chip using pseudo-element */\n.chipLabel::before {\n  content: \"\";\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  /* show small white center with a subtle ring for unchecked */\n  background: radial-gradient(circle at center, #ffffff 55%, #cfcfcf 56%);\n  flex-shrink: 0;\n}\n\n.chipRadio {\n  display: none; /* hide native input - we render indicator via ::before */\n}\n\n.filterGroupName {\n  font-size: 13px;\n  font-weight: 700;\n  color: #222;\n}\n\n.filterItem {\n  margin-bottom: 8px;\n}\n\n.filterItemLabel {\n  font-size: 12px;\n}\n\n.selectAllButton {\n  background: transparent;\n  border: 0;\n  color: #659cd6;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 4px 8px;\n  font-weight: 600;\n}\n\n.suggestionIcon > svg {\n  background-color: #4197b2;\n  color: #fff;\n  font-size: 17px;\n}\n\n.anchorul {\n  list-style-type: none;\n  float: right;\n  position: fixed;\n  right: 0px;\n  max-width: 150px;\n  margin-right: 20px;\n}\n\n.anchorul > li > div {\n  border: none;\n  padding: 5px;\n  background: #fff;\n  border-left: 2px solid #acc6e1;\n  font-size: 12px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 110px;\n  cursor: pointer;\n}\n\n.anchorul > li:active {\n  border: none !important;\n  outline: none !important;\n}\n\n.activeLinkClass {\n  border-left: 2px solid #005cbc !important;\n}\n\n.feedback {\n  position: relative;\n  left: -10%;\n  top: -10px;\n  z-index: 0;\n}\n\n.inputFieldContainer {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  text-align: start;\n  /* margin-left: 5%; */\n  /* make the input/footer area more compact */\n  /* padding: 4px 0; */\n}\n\n.inputFieldGrid {\n  background: #fff;\n  /* bottom: 10px; */\n  position: relative;\n  /* margin: 0 auto !important; */\n  margin: 0 auto;\n  display: block !important;\n  /* display: flex; */\n  /* width: 70% !important; */\n  flex-direction: column;\n  align-items: center;\n  width: 60%;\n  max-width: 1205px;\n}\n\n.autoCompleteItem {\n  width: 100%;\n  display: inline-block;\n  padding: 0px 8px 0px 0px !important;\n}\n\n.query {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 2%;\n  cursor: pointer;\n\n  &:hover {\n    background-color: lightgrey;\n  }\n}\n\n.emptyQueries {\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n}\n\n.clearAll {\n  float: right;\n  background: unset !important;\n  color: #0047ba !important;\n  font-weight: 700;\n  border: unset;\n  padding: unset;\n\n  &:focus {\n    color: black;\n    background: transparent;\n    outline: none;\n    box-shadow: none;\n  }\n}\n\n.dropdown {\n  float: left;\n  position: relative;\n  top: 7px;\n  margin: 0px 10px 10px 50px;\n  display: inline;\n  justify-content: center;\n}\n\n.formControl {\n  margin-right: 10px;\n  height: 20px;\n}\n\n.loadingContainer {\n  margin-top: 5px;\n  position: fixed;\n  bottom: 95px;\n  /* left: 300px; */\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.loadingMessage {\n  font-size: 11px;\n  font-weight: bold;\n  color: transparent;\n  /* background-color: rgba(255, 255, 255, 0.98); */\n  /* padding: 12px 20px; */\n  /* border-radius: 8px; */\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */\n  max-width: 300px;\n  /* text-align: left; */\n  /* background: linear-gradient(90deg, rgb(133, 128, 128) 0%, white 50%, rgb(133, 128, 128) 100%); */\n  /* background: linear-gradient(90deg, black 0%, white 50%, black 100%); */\n  background: black;\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  /* animation: shine 3s infinite linear; */\n  /* animation-duration: 4s; */\n}\n\n@keyframes shine {\n  0% {\n    background-position: 200%;\n  }\n  100% {\n    background-position: -200%;\n  }\n}\n\n.loadingMessage.disabled {\n  animation: none;\n}\n\n@media screen and (min-width: 350px) and (max-width: 500px) {\n  /* .wrapper{\n        margin-top: 60px;\n    } */\n  .aiavatar {\n    margin-right: -5px;\n    margin: 0;\n  }\n\n  .autoCompleteItem {\n    width: 100%;\n  }\n\n  .suggestions {\n    max-width: 80%;\n  }\n\n  .messages {\n    padding-left: unset;\n    padding-right: unset;\n    height: 80vh;\n  }\n\n  .receivedMessage {\n    max-width: 100%;\n  }\n\n  .inputFieldContainer {\n    margin-left: unset;\n  }\n\n  .inputFieldGrid {\n    width: 100% !important;\n  }\n\n  .moreOptionsWeb {\n    display: none;\n  }\n\n  .moreOptionsMobile {\n    float: right;\n    margin-bottom: unset;\n    margin-right: -30px;\n  }\n\n  .anchorul {\n    display: none;\n  }\n\n  .feedback {\n    position: relative;\n    left: -10%;\n    top: 40px;\n    z-index: 0;\n  }\n\n  /* .outerDiv {\n    margin: 120px 0px 0px 0px;\n  } */\n\n  /* .newChatIcon {\n        margin-right: 5px;\n        position: absolute;\n        top: -25px;\n    } */\n\n  /* .disableMicBtn{\n        position: relative;\n        top: 20px;\n    } */\n\n  /* .activeMicIcon{\n        position: relative;\n        top: 20px;\n    } */\n\n  /* .sendIcon {\n        position: relative;\n        top: 18px;\n    } */\n}\n\n@media screen and (min-width: 900px) {\n  .moreOptionsMobile {\n    display: none;\n  }\n\n  .feedback {\n    position: relative;\n    /* margin-left: 25%; */\n    top: 30px;\n    z-index: 0;\n  }\n}\n.summaryIntroText {\n  font-size: 16px; /* Adjust size as needed */\n  font-weight: 300; /* This makes the font regular, not bold */\n  color: #272727; /* A standard, soft text color */\n  margin-bottom: 10px; /* Adds some space before the horizontal line */\n}\n.summarySeparator {\n  border: none;\n  height: 1px;\n  background-color: #a0a0a0; /* A light grey color */\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n/* In ChatBotComponent.module.css */\n\n/* In ChatBotComponent.module.css */\n/* Remove .topFilterContainer, .dropdown, and old .filterAccordionHeader/.filterTitle styles */\n\n/* This is the main card container for the entire filter panel */\n.filterPanelContainer {\n  /* position: fixed; */\n  /* background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%); */\n  /* background: linear-gradient(180deg, #f4f8ff 0%, #edf4ff 100%); */\n  border-radius: 14px;\n  /* border: 1px solid #dce8f8; */\n  /* box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08); */\n  /* margin-bottom: 16px; */\n  padding: 10px 10px 6px 10px; /* top, right, bottom, left*/\n  /* max-width: 1280px;  */\n  width: 100%; /* This makes it take the full available width */\n  /* max-width and margin-left/right are removed */\n  /* width: 100%;\n  min-width: 1024px; optional: set a fixed min width if needed */\n  box-sizing: border-box;\n  /* max-width: 900px; */\n  justify-content: space-between;\n}\n\n/* Styles for the clickable header area */\n.filterAccordionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 0 0 0px 5px; /* Reduced padding */\n}\n\n/* Refined style for the title text */\n.filterTitle {\n  font-size: 12px; /* Slightly larger */\n  font-weight: 500;\n  color: #08090b; /* Softer black */\n  margin: -10;\n}\n\n/* This new class adds padding to the content inside the collapsible area */\n.topFilterContainer {\n  padding: 0 0 0 -10; /* Only top padding, no side padding */\n}\n\n/* This is the container for each label + dropdown pair */\n.filterItem {\n  display: flex;\n  /* min-Width: 180; */\n  padding-top: -20px; /* Adjusts the space above the label */\n  flex-direction: column;\n  gap: -40px; /* Controls the space between the label and the dropdown */\n  /* padding: auto;*/\n}\n\n.regionColumn {\n  flex: 0 0 300px;\n  max-width: 340px;\n}\n.filterItemLabel {\n  font-size: 12px;\n  font-weight: 400;\n  color: #000000; /* A professional, slightly muted text color */\n  /* margin-left: 10px; */\n  text-transform: capitalize; /* Ensures consistent casing */\n}\n\n.pageWrapper {\n  /* max-width: 1280px; */\n  /* margin-top: 4rem; */\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: calc(100vh - 6rem);\n  /* height: calc(80vh); */\n  box-sizing: border-box;\n  /* padding: 0 16px; */\n}\n\n.stickyContainer {\n  position: fixed;\n  top: 50px;\n  z-index: 10;\n  /* margin-right: 5%; */\n  /* width: 90%; */\n  /* align-items: center; */\n  /* box-shadow: 0 0px 0px rgba(234, 233, 233, 0.05); */\n  min-height: 60px;\n  box-sizing: border-box;\n}\n\n.scrollableContent {\n  margin-top: 104px; /* Adjust for combined header height (first: ~44px + second: ~52px) */\n  /* height: calc(100vh - 10px); */\n  flex-grow: 1;\n  overflow-y: auto;\n  z-index: 5;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  position: relative;\n\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  /* padding: 8px; */\n  margin: 0;\n  /* margin-right: 2%; */\n  /* Allow pointer events to pass through to scrollbar */\n  pointer-events: auto;\n  width: 100%;\n}\n\n/* Hide scrollbar for summary mode (default) */\n.scrollableContent::-webkit-scrollbar {\n  display: none;\n}\n\n/* Show scrollbar ONLY for chat mode */\n.scrollableContent[data-ui-mode=\"chat\"] {\n  scrollbar-width: auto;\n  -ms-overflow-style: auto;\n  overflow-y: scroll;\n}\n\n.scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar {\n  display: block;\n  width: 12px;\n}\n\n.scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar-thumb {\n  background: #a0b8d4;\n  border-radius: 6px;\n  min-height: 40px;\n  background-clip: padding-box;\n  border: 2px solid transparent;\n}\n\n.scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar-track {\n  background: #f0f4fa;\n  border-radius: 8px;\n}\n\n/* In summary mode, keep outer area fixed and let only the inner right content panel scroll. */\n.scrollableContent[data-ui-mode=\"summary\"] {\n  overflow: hidden;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* On mobile, ensure scrollbar is always visible and wider for chat mode */\n@media screen and (max-width: 900px) {\n  .scrollableContent[data-ui-mode=\"chat\"] {\n    scrollbar-width: auto !important;\n    overflow-y: scroll !important;\n  }\n\n  .scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar {\n    display: block;\n    width: 14px;\n  }\n\n  .scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar-thumb {\n    background: #7a94b8;\n    border-radius: 7px;\n  }\n\n  .scrollableContent[data-ui-mode=\"chat\"]::-webkit-scrollbar-track {\n    background: #e8eef8;\n  }\n}\n\n/* Ensure scrollable content is always interactive even during loading */\n.scrollableContent * {\n  pointer-events: auto !important;\n}\n\n.scrollButtonsWrapper,\n.scrollButtonsContainer {\n  /* Fixed at the bottom center so placement is consistent across screen sizes\n     Raised to sit above the input field and tips area */\n  position: fixed;\n  bottom: 97px; /* moved up so buttons appear above chat input */\n  left: 50%;\n  transform: translateX(-50%);\n\n  display: flex;\n  gap: 10px;\n  background: transparent;\n  z-index: 1200; /* ensure above other content */\n}\n\n.scrollButton {\n  background: none;\n  border: none;\n  color: #4a484f;\n  /* font-weight: 700; */\n  font-size: 17px;\n  /* cursor: pointer; */\n  padding: 0;\n  outline: none;\n  /* transition: color 0.3s ease-in-out, transform 0.2s ease-in-out; */\n}\n\n/* Larger hit target for touch devices */\n.scrollButton {\n  /* width: 40px; */\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n}\n\n.scrollButton:hover {\n  color: #161517;\n  transform: scale(1.1);\n}\n.scrollButton:focus {\n  outline: none;\n  transform: scale(1.1); /* slight click animation */\n}\n.actionBar {\n  display: flex; /* Aligns children (options and feedback icons) in a row */\n  align-items: center; /* Vertically centers the items in the bar */\n  gap: 8px;\n  margin-top: 0px; /* Adds some space above the action bar */\n  justify-content: flex-end;\n  padding-bottom: 10px;\n}\n\n/* Styles for the feedback icons container */\n.feedback {\n  display: flex;\n  gap: 8px;\n  position: static;\n  top: auto;\n  left: auto;\n  align-items: center;\n  justify-content: flex-end;\n  padding-left: 0;\n  margin-left: auto;\n}\n.feedback :global(.mr15) {\n  margin-right: 0 !important;\n}\n.feedback svg {\n  width: 28px;\n  height: 28px;\n  padding: 7px;\n  border: 1px solid #d5dbe5;\n  border-radius: 999px;\n  background: #f7f9fc;\n  color: #005CBC;\n  box-sizing: border-box;\n}\n\n/* Period comparison panel styles */\n.periodPanelContent {\n  margin-top: 5px;\n}\n\n.selectedRangeBox {\n  margin-top: 5px;\n  padding: 0 12px;\n  background: #ffffff;\n  border-radius: 6px;\n  color: #444;\n  font-size: 0.7rem;\n  display: flex;\n  align-items: center; /* vertical centering */\n  justify-content: center; /* horizontal centering */\n  text-align: center; /* fallback for inline text */\n  border: 1px solid #e0e0e0;\n  width: 100%;\n  max-width: 280px; /* align with MonthRangePicker.module.css pickerContainer max-width */\n  box-sizing: border-box;\n  min-height: 20px; /* ensure enough height to vertically center the placeholder */\n}\n\n@media screen and (max-width: 900px) {\n  /* Stack the two period panels on small screens */\n  .periodPanelContent {\n    width: 100% !important;\n  }\n\n  /* Make scroll buttons slightly closer together and nearer to the bottom on small screens */\n  .scrollButtonsWrapper,\n  .scrollButtonsContainer {\n    bottom: 64px;\n    /* gap: 12px; */\n  }\n}\n/* Add these to ChatBotComponent.module.css */\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  /* margin-bottom: 16px; */\n}\n\n.filterGroupHeader {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  /* margin-bottom: 8px; */\n}\n\n/* Variant for when we want the action (Clear/Select All) inline with the label */\n.filterGroupHeaderInline {\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n/* Wrapper to keep label and action compact and aligned to the left */\n.filterGroupHeaderInlineWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  justify-content: flex-start; /* keep Clear button next to label */\n}\n\n.filterGroupName {\n  font-weight: bold;\n  font-size: 0.7rem;\n  color: #333;\n}\n\n.selectAllButton {\n  font-size: 0.6rem;\n  color: #659cd6;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n}\n\n.chipContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.retailerChipContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.regionRetailerRow {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  align-items: flex-start;\n}\n\n@media (max-width: 768px) {\n  .retailerChipContainer {\n    flex-direction: column;\n    flex-wrap: nowrap;\n    align-items: stretch;\n  }\n  .regionColumn {\n    flex: 0 0 0px;\n    max-width: 340px;\n  }\n  .regionRetailerRow {\n    flex-direction: column;\n    gap: 16px; /* Add some vertical space between the stacked sections */\n  }\n\n  /* Ensure each section takes the full width on mobile */\n  .regionRetailerRow > div {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n/* Vertical layout specifically for Category chips (single-select radio list) */\n.categoryChipContainer {\n  display: flex;\n  flex-direction: column;\n  /* gap: 6px; tightened vertical spacing for category list */\n  max-height: 420px; /* allow scrolling if too many categories */\n  overflow-y: auto;\n}\n\n/* Make category chips compact: don't force them to stretch full tile width.\n   Use inline-flex so the pill sizes to its content but never exceeds the tile width. */\n.categoryChipContainer {\n  align-items: stretch; /* keep vertical stacking */\n}\n.categoryChipContainer .chipLabel {\n  display: flex; /* uniform fixed-width pill */\n  align-items: center;\n  justify-content: flex-start;\n  width: 50%;\n  /* padding: 6px 6px; */\n  border-radius: 12px; /* slightly rounded rectangular */\n  box-sizing: border-box;\n  /* height: 31px;  */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Make the input-radio pseudo and label align well when the container scrolls */\n.categoryChipContainer input[type=\"radio\"] + .chipLabel {\n  box-sizing: border-box;\n}\n\n.chipRadio {\n  display: none; /* Hide the actual radio button */\n}\n\n/* Checked state: blue filled pill and updated indicator */\n.chipRadio:checked + .chipLabel {\n  background-color: #327ec9; /* brand blue when selected */\n  border-color: #327ec9;\n  color: #ffffff;\n  box-shadow: 0 6px 16px rgba(43, 143, 230, 0.12);\n}\n\n.chipRadio:checked + .chipLabel::before {\n  /* white center with colored ring using radial-gradient to show the circular indicator */\n  background: radial-gradient(circle at center, #ffffff 55%, #327ec9 56%);\n}\n.filterGroup:not(:last-child) {\n  border-bottom: 1px dotted #e0e0e0;\n  /* padding-bottom: 16px; Adds some space between the content and the divider */\n}\n.filter_button {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) and (max-width: 900px) {\n  .filterHamburgerButton {\n    position: absolute !important;\n    top: 5px;\n    right: 5px;\n    z-index: 1300;\n    background-color: #ffffff !important;\n  }\n  .mobileFilterDrawer {\n    width: 300px;\n    padding: 1rem;\n    box-sizing: border-box;\n  }\n  .drawerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 10px;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  .drawerTitle {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #333;\n  }\n  /* Make each filter dropdown take the full width to stack vertically */\n  .filterItem {\n    flex-basis: 100%;\n    min-width: unset;\n  }\n  /* Hide hover-based side panels as they are not touch-friendly */\n  .sidePanelTrigger,\n  .rightSidePanelTrigger,\n  .sidePanel,\n  .rightSidePanel {\n    display: none;\n  }\n  .filterTitle {\n    font-size: 13px; /* Kept from original tablet styles */\n    line-height: 1.4;\n  }\n  .scrollableContent,\n  .scrollableContent.filtersExpanded {\n    /* Target both the base and expanded states */\n    margin-left: auto;\n    margin-right: auto;\n    padding:0 8px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 100%;\n    max-width: 1280px;\n  }\n  .pageWrapper {\n    height: calc(100vh - 12rem);\n    /* display: contents; */\n  }\n  .messages {\n    padding: 50px;\n    display: block;\n    position: relative;\n  }\n  .sentMessage,\n  .receivedMessage {\n    max-width: 100%;\n    font-size: 14px;\n  }\n\n  /* Ensure the input area takes full width */\n  .inputFieldContainer {\n    margin-left: 0;\n    padding: 0 4px;\n    box-sizing: border-box;\n  }\n\n  /* Hide hover-based side panels as they are not touch-friendly */\n  .sidePanelTrigger,\n  .rightSidePanelTrigger,\n  .sidePanel,\n  .rightSidePanel {\n    display: none;\n  }\n\n  /* Align feedback icons to the left */\n  .feedback {\n    padding-left: 0;\n    justify-content: flex-end;\n  }\n  .filter_button{\n    flex-direction: column;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  body {\n    overflow: hidden;\n  }\n  .filterHamburgerButton {\n    position: absolute !important;\n    top: 5px;\n    right: 5px;\n    z-index: 1300; /* Ensure it's on top */\n    background-color: #ffffff !important;\n    /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); */\n  }\n  .mobileFilterDrawer {\n    width: 300px; /* Or whatever width you prefer */\n    padding: 1rem;\n    box-sizing: border-box;\n  }\n  .drawerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 10px;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #e0e0e0; /* Adds a nice separator line */\n  }\n\n  .drawerTitle {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #333;\n  }\n\n  /* Adjust the chat content area to flow naturally */\n  .scrollableContent,\n  .scrollableContent.filtersExpanded {\n    /* Target both the base and expanded states */\n    margin-top: 0; /* Ensure margin is always 0 on mobile */\n    padding: 0 10px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n .scrollableContent[data-ui-mode=\"summary\"] {\n    /* margin-top: 20%; */\n    position: absolute;\n    padding: 0px 10px;\n    top: 112px;\n  }\n\n  .pageWrapper {\n    /* margin-top: 30px; */\n    height: calc(100vh - 11rem);\n    /* display: contents; */\n  }\n\n  /* Make each filter dropdown take the full width to stack vertically */\n  .filterItem {\n    flex-basis: 100%;\n    min-width: unset;\n  }\n\n  .filterTitle {\n    font-size: 12px;\n  }\n\n  /* Adjust message padding and max-width for better readability */\n  .messages {\n    padding: 10px;\n    display: block;\n    position: relative;\n  }\n  .sentMessage,\n  .receivedMessage {\n    max-width: 100%;\n    font-size: 14px;\n  }\n\n  /* Ensure the input area takes full width */\n  .inputFieldContainer {\n    margin-left: 0;\n    padding: 0 4px;\n    box-sizing: border-box;\n  }\n\n  /* Hide hover-based side panels as they are not touch-friendly */\n  .sidePanelTrigger,\n  .rightSidePanelTrigger,\n  .sidePanel,\n  .rightSidePanel {\n    display: none;\n  }\n\n  /* Align feedback icons to the left */\n  .feedback {\n    padding-left: 0;\n    justify-content: flex-end;\n  }\n\n  /* Hide the floating scroll-to-question list */\n  .anchorul {\n    display: none;\n  }\n   .filter_button{\n    flex-direction: column;\n  }\n}\n.custom-btn:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatbotMiddle": `ChatBotComponent_chatbotMiddle__+9hva`,
	"responsiveContainer": `ChatBotComponent_responsiveContainer__Nm1aC`,
	"filterTileCard": `ChatBotComponent_filterTileCard__QMZwf`,
	"smallFilterTile": `ChatBotComponent_smallFilterTile__yKyou`,
	"pickerContainer": `ChatBotComponent_pickerContainer__kyaKu`,
	"monthButton": `ChatBotComponent_monthButton__Vs60Q`,
	"chipLabel": `ChatBotComponent_chipLabel__ErYCu`,
	"chipRadio": `ChatBotComponent_chipRadio__MH4Zf`,
	"filterPanelContainer": `ChatBotComponent_filterPanelContainer__dyxCz`,
	"filterGroupName": `ChatBotComponent_filterGroupName__5oxL+`,
	"selectAllButton": `ChatBotComponent_selectAllButton__bBRz9`,
	"regionRetailerRow": `ChatBotComponent_regionRetailerRow__Rwz5E`,
	"chipContainer": `ChatBotComponent_chipContainer__Uu3JF`,
	"retailerChipContainer": `ChatBotComponent_retailerChipContainer__jCcly`,
	"categoryChipContainer": `ChatBotComponent_categoryChipContainer__Ouvf6`,
	"regionColumn": `ChatBotComponent_regionColumn__GPVW4`,
	"selectedRangeBox": `ChatBotComponent_selectedRangeBox__14UJD`,
	"periodPickerRow": `ChatBotComponent_periodPickerRow__btZam`,
	"pickerColumn": `ChatBotComponent_pickerColumn__uwzRS`,
	"applyFiltersRow": `ChatBotComponent_applyFiltersRow__m8d8b`,
	"MuiButtonBase-root": `ChatBotComponent_MuiButtonBase-root__dkKni`,
	"categoryWithPeriod": `ChatBotComponent_categoryWithPeriod__tmU5o`,
	"categoryWithPeriodRow": `ChatBotComponent_categoryWithPeriodRow__64O8G`,
	"chatbotBottom": `ChatBotComponent_chatbotBottom__4QxSU`,
	"messages": `ChatBotComponent_messages__xqD4K`,
	"tipsClass": `ChatBotComponent_tipsClass__GU20D`,
	"tipsIcon": `ChatBotComponent_tipsIcon__HQwG1`,
	"sentMessage": `ChatBotComponent_sentMessage__Vpyor`,
	"receivedMessage": `ChatBotComponent_receivedMessage__l4GNP`,
	"mainDiv": `ChatBotComponent_mainDiv__M6NPd`,
	"closeIcon": `ChatBotComponent_closeIcon__MDnVh`,
	"userFeedbackContainer": `ChatBotComponent_userFeedbackContainer__rPEPT`,
	"gridContainer": `ChatBotComponent_gridContainer__OEAVS`,
	"sidePanelTrigger": `ChatBotComponent_sidePanelTrigger__IQ+KC`,
	"table-responsive": `ChatBotComponent_table-responsive__4zPaN`,
	"sidePanel": `ChatBotComponent_sidePanel__bzr5+`,
	"sidePanelContent": `ChatBotComponent_sidePanelContent__luY3u`,
	"rightSidePanelTrigger": `ChatBotComponent_rightSidePanelTrigger__5-rFo`,
	"rightSidePanel": `ChatBotComponent_rightSidePanel__+6FDA`,
	"rightSidePanelContent": `ChatBotComponent_rightSidePanelContent__YGdww`,
	"outerDiv": `ChatBotComponent_outerDiv__o1cWl`,
	"plusIcon": `ChatBotComponent_plusIcon__2NZ5S`,
	"newChatIcon": `ChatBotComponent_newChatIcon__b8Syt`,
	"disableMicBtn": `ChatBotComponent_disableMicBtn__MRqxx`,
	"activeMicIcon": `ChatBotComponent_activeMicIcon__Y6bD-`,
	"chat_message": `ChatBotComponent_chat_message__p29Hz`,
	"histText": `ChatBotComponent_histText__zvO2N`,
	"semiDividerHome": `ChatBotComponent_semiDividerHome__b1-Tb`,
	"typing_effect": `ChatBotComponent_typing_effect__IGJUR`,
	"typing": `ChatBotComponent_typing__Rvd0l`,
	"generateInsightsGridRow": `ChatBotComponent_generateInsightsGridRow__zOmZO`,
	"generateInsightsGridCell": `ChatBotComponent_generateInsightsGridCell__nru8z`,
	"generateInsightsGridRetailerStore": `ChatBotComponent_generateInsightsGridRetailerStore__grAqO`,
	"chipCls": `ChatBotComponent_chipCls__O93dy`,
	"intro": `ChatBotComponent_intro__pxFcm`,
	"alignCenter": `ChatBotComponent_alignCenter__c7q1M`,
	"sendIcon": `ChatBotComponent_sendIcon__16hRo`,
	"avatar": `ChatBotComponent_avatar__mssXo`,
	"chatBotSvg": `ChatBotComponent_chatBotSvg__I8DVd`,
	"aiavatar": `ChatBotComponent_aiavatar__hB3IO`,
	"moreOptions": `ChatBotComponent_moreOptions__-yECI`,
	"aiChatMessage": `ChatBotComponent_aiChatMessage__EtOEd`,
	"suggestionBtn": `ChatBotComponent_suggestionBtn__Qz-Xc`,
	"suggestionIcon": `ChatBotComponent_suggestionIcon__GkhAB`,
	"filterItem": `ChatBotComponent_filterItem__pxw5j`,
	"filterItemLabel": `ChatBotComponent_filterItemLabel__-niuQ`,
	"anchorul": `ChatBotComponent_anchorul__M2Ute`,
	"activeLinkClass": `ChatBotComponent_activeLinkClass__RH7vk`,
	"feedback": `ChatBotComponent_feedback__e56Zw`,
	"inputFieldContainer": `ChatBotComponent_inputFieldContainer__L6LZH`,
	"inputFieldGrid": `ChatBotComponent_inputFieldGrid__Efcfi`,
	"autoCompleteItem": `ChatBotComponent_autoCompleteItem__2o0Il`,
	"query": `ChatBotComponent_query__Gli9n`,
	"emptyQueries": `ChatBotComponent_emptyQueries__rz7aj`,
	"clearAll": `ChatBotComponent_clearAll__JSAXp`,
	"dropdown": `ChatBotComponent_dropdown__GzPpF`,
	"formControl": `ChatBotComponent_formControl__QSxO2`,
	"loadingContainer": `ChatBotComponent_loadingContainer__8Iccr`,
	"loadingMessage": `ChatBotComponent_loadingMessage__Mdp0D`,
	"disabled": `ChatBotComponent_disabled__6zhSw`,
	"suggestions": `ChatBotComponent_suggestions__Fr-sf`,
	"moreOptionsWeb": `ChatBotComponent_moreOptionsWeb__9w2DN`,
	"moreOptionsMobile": `ChatBotComponent_moreOptionsMobile__66hGc`,
	"summaryIntroText": `ChatBotComponent_summaryIntroText__DnzTB`,
	"summarySeparator": `ChatBotComponent_summarySeparator__pSUJC`,
	"filterAccordionHeader": `ChatBotComponent_filterAccordionHeader__ATdbq`,
	"filterTitle": `ChatBotComponent_filterTitle__jfT6o`,
	"topFilterContainer": `ChatBotComponent_topFilterContainer__zP9Gw`,
	"pageWrapper": `ChatBotComponent_pageWrapper__KA2L+`,
	"stickyContainer": `ChatBotComponent_stickyContainer__jLXzU`,
	"scrollableContent": `ChatBotComponent_scrollableContent__9bHZA`,
	"scrollButtonsWrapper": `ChatBotComponent_scrollButtonsWrapper__cF4rP`,
	"scrollButtonsContainer": `ChatBotComponent_scrollButtonsContainer__YldJ3`,
	"scrollButton": `ChatBotComponent_scrollButton__57Kl1`,
	"actionBar": `ChatBotComponent_actionBar__uPg+o`,
	"periodPanelContent": `ChatBotComponent_periodPanelContent__9hqs1`,
	"filterGroup": `ChatBotComponent_filterGroup__siFbA`,
	"filterGroupHeader": `ChatBotComponent_filterGroupHeader__FsORy`,
	"filterGroupHeaderInline": `ChatBotComponent_filterGroupHeaderInline__2Lq4J`,
	"filterGroupHeaderInlineWrap": `ChatBotComponent_filterGroupHeaderInlineWrap__UG7F7`,
	"filter_button": `ChatBotComponent_filter_button__Q8dqx`,
	"filterHamburgerButton": `ChatBotComponent_filterHamburgerButton__BMlTc`,
	"mobileFilterDrawer": `ChatBotComponent_mobileFilterDrawer__4VygA`,
	"drawerHeader": `ChatBotComponent_drawerHeader__AdUQz`,
	"drawerTitle": `ChatBotComponent_drawerTitle__W5Neb`,
	"filtersExpanded": `ChatBotComponent_filtersExpanded__b5TIo`,
	"custom-btn": `ChatBotComponent_custom-btn__uH8mU`,
	"shine": `ChatBotComponent_shine__WUR1u`
};
export default ___CSS_LOADER_EXPORT___;
